/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
  If you need to add or edit existing variables, check out
  discord_common/js/packages/tokens/definitions, then run
  `clyde mana tokens generate`
*/

const Colors = Object.freeze({
  APPLICATION_SUBSCRIPTION_END: 'hsl(197, calc(var(--saturation-factor, 1) * 98.8%), 32.4%)',
  APPLICATION_SUBSCRIPTION_START: 'hsl(235, calc(var(--saturation-factor, 1) * 68.5%), 52.7%)',
  BATTLENET: 'hsl(200, calc(var(--saturation-factor, 1) * 100.0%), 44.9%)',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_1: 'hsl(242, calc(var(--saturation-factor, 1) * 57.1%), 27.5%)',
  BG_ANIMATED_GRADIENT_BACKGROUND_INDIGO_2: 'hsl(257, calc(var(--saturation-factor, 1) * 100.0%), 20.0%)',
  BG_ANIMATED_GRADIENT_BACKGROUND_NOT_BLACK: 'hsl(240, calc(var(--saturation-factor, 1) * 7.1%), 5.5%)',
  BG_ANIMATED_GRADIENT_BACKGROUND_PINK_1: 'hsl(328, calc(var(--saturation-factor, 1) * 80.6%), 59.6%)',
  BG_GRADIENT_AURORA_1: 'hsl(220, calc(var(--saturation-factor, 1) * 86.5%), 17.5%)',
  BG_GRADIENT_AURORA_2: 'hsl(238, calc(var(--saturation-factor, 1) * 76.4%), 41.6%)',
  BG_GRADIENT_AURORA_3: 'hsl(184, calc(var(--saturation-factor, 1) * 78.0%), 33.9%)',
  BG_GRADIENT_AURORA_4: 'hsl(169, calc(var(--saturation-factor, 1) * 60.2%), 32.5%)',
  BG_GRADIENT_AURORA_5: 'hsl(230, calc(var(--saturation-factor, 1) * 92.5%), 26.3%)',
  BG_GRADIENT_BLURPLE_TWILIGHT_1: 'hsl(234, calc(var(--saturation-factor, 1) * 79.6%), 53.9%)',
  BG_GRADIENT_BLURPLE_TWILIGHT_2: 'hsl(245, calc(var(--saturation-factor, 1) * 63.7%), 31.4%)',
  BG_GRADIENT_CHROMA_GLOW_1: 'hsl(183, calc(var(--saturation-factor, 1) * 86.3%), 40.2%)',
  BG_GRADIENT_CHROMA_GLOW_2: 'hsl(258, calc(var(--saturation-factor, 1) * 89.8%), 46.3%)',
  BG_GRADIENT_CHROMA_GLOW_3: 'hsl(298, calc(var(--saturation-factor, 1) * 90.9%), 34.3%)',
  BG_GRADIENT_CHROMA_GLOW_4: 'hsl(265, calc(var(--saturation-factor, 1) * 100.0%), 66.3%)',
  BG_GRADIENT_CHROMA_GLOW_5: 'hsl(207, calc(var(--saturation-factor, 1) * 75.5%), 50.4%)',
  BG_GRADIENT_CITRUS_SHERBERT_1: 'hsl(40, calc(var(--saturation-factor, 1) * 88.7%), 58.2%)',
  BG_GRADIENT_CITRUS_SHERBERT_2: 'hsl(18, calc(var(--saturation-factor, 1) * 81.5%), 63.9%)',
  BG_GRADIENT_COTTON_CANDY_1: 'hsl(349, calc(var(--saturation-factor, 1) * 76.8%), 81.4%)',
  BG_GRADIENT_COTTON_CANDY_2: 'hsl(226, calc(var(--saturation-factor, 1) * 92.6%), 84.1%)',
  BG_GRADIENT_CRIMSON_MOON_1: 'hsl(0, calc(var(--saturation-factor, 1) * 88.6%), 31.0%)',
  BG_GRADIENT_CRIMSON_MOON_2: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BG_GRADIENT_DESERT_KHAKI_1: 'hsl(29, calc(var(--saturation-factor, 1) * 32.4%), 86.1%)',
  BG_GRADIENT_DESERT_KHAKI_2: 'hsl(40, calc(var(--saturation-factor, 1) * 41.3%), 78.6%)',
  BG_GRADIENT_DESERT_KHAKI_3: 'hsl(50, calc(var(--saturation-factor, 1) * 49.6%), 75.9%)',
  BG_GRADIENT_DUSK_1: 'hsl(293, calc(var(--saturation-factor, 1) * 13.5%), 36.3%)',
  BG_GRADIENT_DUSK_2: 'hsl(223, calc(var(--saturation-factor, 1) * 41.0%), 69.4%)',
  BG_GRADIENT_EASTER_EGG_1: 'hsl(227, calc(var(--saturation-factor, 1) * 58.4%), 65.1%)',
  BG_GRADIENT_EASTER_EGG_2: 'hsl(227, calc(var(--saturation-factor, 1) * 31.0%), 44.3%)',
  BG_GRADIENT_FOREST_1: 'hsl(124, calc(var(--saturation-factor, 1) * 25.9%), 10.6%)',
  BG_GRADIENT_FOREST_2: 'hsl(143, calc(var(--saturation-factor, 1) * 26.2%), 23.9%)',
  BG_GRADIENT_FOREST_3: 'hsl(76, calc(var(--saturation-factor, 1) * 20.6%), 24.7%)',
  BG_GRADIENT_FOREST_4: 'hsl(117, calc(var(--saturation-factor, 1) * 17.0%), 41.6%)',
  BG_GRADIENT_FOREST_5: 'hsl(43, calc(var(--saturation-factor, 1) * 38.5%), 47.8%)',
  BG_GRADIENT_HANAMI_1: 'hsl(352, calc(var(--saturation-factor, 1) * 68.3%), 80.2%)',
  BG_GRADIENT_HANAMI_2: 'hsl(43, calc(var(--saturation-factor, 1) * 73.6%), 76.3%)',
  BG_GRADIENT_HANAMI_3: 'hsl(116, calc(var(--saturation-factor, 1) * 43.1%), 74.5%)',
  BG_GRADIENT_LOFI_VIBES_1: 'hsl(220, calc(var(--saturation-factor, 1) * 83.8%), 80.6%)',
  BG_GRADIENT_LOFI_VIBES_2: 'hsl(184, calc(var(--saturation-factor, 1) * 57.8%), 78.6%)',
  BG_GRADIENT_LOFI_VIBES_3: 'hsl(130, calc(var(--saturation-factor, 1) * 46.3%), 78.8%)',
  BG_GRADIENT_LOFI_VIBES_4: 'hsl(76, calc(var(--saturation-factor, 1) * 48.8%), 75.5%)',
  BG_GRADIENT_MARS_1: 'hsl(15, calc(var(--saturation-factor, 1) * 36.3%), 39.4%)',
  BG_GRADIENT_MARS_2: 'hsl(0, calc(var(--saturation-factor, 1) * 36.2%), 41.2%)',
  BG_GRADIENT_MIDNIGHT_BLURPLE_1: 'hsl(245, calc(var(--saturation-factor, 1) * 55.1%), 53.7%)',
  BG_GRADIENT_MIDNIGHT_BLURPLE_2: 'hsl(259, calc(var(--saturation-factor, 1) * 74.5%), 10.8%)',
  BG_GRADIENT_MINT_APPLE_1: 'hsl(166, calc(var(--saturation-factor, 1) * 39.7%), 52.5%)',
  BG_GRADIENT_MINT_APPLE_2: 'hsl(119, calc(var(--saturation-factor, 1) * 40.4%), 55.9%)',
  BG_GRADIENT_MINT_APPLE_3: 'hsl(87, calc(var(--saturation-factor, 1) * 48.3%), 59.8%)',
  BG_GRADIENT_NEON_NIGHTS_1: 'hsl(176, calc(var(--saturation-factor, 1) * 98.8%), 33.1%)',
  BG_GRADIENT_NEON_NIGHTS_2: 'hsl(259, calc(var(--saturation-factor, 1) * 39.5%), 55.3%)',
  BG_GRADIENT_NEON_NIGHTS_3: 'hsl(314, calc(var(--saturation-factor, 1) * 52.5%), 46.3%)',
  BG_GRADIENT_RETRO_RAINCLOUD_1: 'hsl(202, calc(var(--saturation-factor, 1) * 47.0%), 42.9%)',
  BG_GRADIENT_RETRO_RAINCLOUD_2: 'hsl(241, calc(var(--saturation-factor, 1) * 29.6%), 61.0%)',
  BG_GRADIENT_RETRO_STORM_1: 'hsl(202, calc(var(--saturation-factor, 1) * 47.0%), 42.9%)',
  BG_GRADIENT_RETRO_STORM_2: 'hsl(241, calc(var(--saturation-factor, 1) * 27.8%), 47.3%)',
  BG_GRADIENT_SEPIA_1: 'hsl(33, calc(var(--saturation-factor, 1) * 14.2%), 45.7%)',
  BG_GRADIENT_SEPIA_2: 'hsl(36, calc(var(--saturation-factor, 1) * 46.8%), 24.3%)',
  BG_GRADIENT_STRAWBERRY_LEMONADE_1: 'hsl(327, calc(var(--saturation-factor, 1) * 74.1%), 39.4%)',
  BG_GRADIENT_STRAWBERRY_LEMONADE_2: 'hsl(28, calc(var(--saturation-factor, 1) * 71.7%), 44.3%)',
  BG_GRADIENT_STRAWBERRY_LEMONADE_3: 'hsl(40, calc(var(--saturation-factor, 1) * 80.2%), 52.5%)',
  BG_GRADIENT_SUNRISE_1: 'hsl(327, calc(var(--saturation-factor, 1) * 42.0%), 43.9%)',
  BG_GRADIENT_SUNRISE_2: 'hsl(27, calc(var(--saturation-factor, 1) * 44.9%), 58.0%)',
  BG_GRADIENT_SUNRISE_3: 'hsl(50, calc(var(--saturation-factor, 1) * 46.3%), 44.5%)',
  BG_GRADIENT_SUNSET_1: 'hsl(259, calc(var(--saturation-factor, 1) * 55.6%), 35.3%)',
  BG_GRADIENT_SUNSET_2: 'hsl(22, calc(var(--saturation-factor, 1) * 66.7%), 57.6%)',
  BG_GRADIENT_UNDER_THE_SEA_1: 'hsl(115, calc(var(--saturation-factor, 1) * 10.5%), 42.9%)',
  BG_GRADIENT_UNDER_THE_SEA_2: 'hsl(159, calc(var(--saturation-factor, 1) * 20.4%), 43.3%)',
  BG_GRADIENT_UNDER_THE_SEA_3: 'hsl(175, calc(var(--saturation-factor, 1) * 10.9%), 46.7%)',
  BG_MODAL_GRADIENT_GREEN_DARK_1: 'hsl(146, calc(var(--saturation-factor, 1) * 70.8%), 42.9%)',
  BG_MODAL_GRADIENT_GREEN_DARK_2: 'hsl(153, calc(var(--saturation-factor, 1) * 100.0%), 20.0%)',
  BG_MODAL_GRADIENT_GREEN_LIGHT_1: 'hsl(145, calc(var(--saturation-factor, 1) * 100.0%), 94.9%)',
  BG_MODAL_GRADIENT_GREEN_LIGHT_2: 'hsl(144, calc(var(--saturation-factor, 1) * 87.2%), 75.5%)',
  BG_MODAL_GRADIENT_LAVENDER_DARK_1: 'hsl(268, calc(var(--saturation-factor, 1) * 85.7%), 64.3%)',
  BG_MODAL_GRADIENT_LAVENDER_DARK_2: 'hsl(261, calc(var(--saturation-factor, 1) * 72.3%), 31.2%)',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_1: 'hsl(269, calc(var(--saturation-factor, 1) * 90.6%), 87.5%)',
  BG_MODAL_GRADIENT_LAVENDER_LIGHT_2: 'hsl(269, calc(var(--saturation-factor, 1) * 88.3%), 79.8%)',
  BG_MODAL_GRADIENT_MAGENTA_DARK_1: 'hsl(310, calc(var(--saturation-factor, 1) * 65.0%), 42.5%)',
  BG_MODAL_GRADIENT_MAGENTA_DARK_2: 'hsl(300, calc(var(--saturation-factor, 1) * 100.0%), 20.0%)',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_1: 'hsl(290, calc(var(--saturation-factor, 1) * 100.0%), 95.1%)',
  BG_MODAL_GRADIENT_MAGENTA_LIGHT_2: 'hsl(312, calc(var(--saturation-factor, 1) * 96.2%), 79.6%)',
  BG_MODAL_GRADIENT_NAVY_DARK_1: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  BG_MODAL_GRADIENT_NAVY_DARK_2: 'hsl(238, calc(var(--saturation-factor, 1) * 72.5%), 31.4%)',
  BG_MODAL_GRADIENT_NAVY_LIGHT_1: 'hsl(235, calc(var(--saturation-factor, 1) * 90.5%), 87.6%)',
  BG_MODAL_GRADIENT_NAVY_LIGHT_2: 'hsl(234, calc(var(--saturation-factor, 1) * 90.0%), 80.4%)',
  BG_TILE_GRADIENT_MAGENTA_DARK_1: 'hsl(310, calc(var(--saturation-factor, 1) * 65.0%), 42.5%)',
  BG_TILE_GRADIENT_MAGENTA_DARK_2: 'hsl(300, calc(var(--saturation-factor, 1) * 100.0%), 20.0%)',
  BLACK: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 94.9%)',
  BLACK_130: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 91.0%)',
  BLACK_160: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 85.5%)',
  BLACK_200: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 80.0%)',
  BLACK_230: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 74.1%)',
  BLACK_260: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 67.5%)',
  BLACK_300: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 60.0%)',
  BLACK_330: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 47.8%)',
  BLACK_345: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 40.0%)',
  BLACK_360: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 36.1%)',
  BLACK_400: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 20.0%)',
  BLACK_430: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 14.5%)',
  BLACK_460: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 7.8%)',
  BLACK_500: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_530: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_560: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_600: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_630: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_660: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_700: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_730: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_760: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_800: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_830: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_860: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLACK_900: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLUE_100: 'hsl(210, calc(var(--saturation-factor, 1) * 80.0%), 98.0%)',
  BLUE_130: 'hsl(210, calc(var(--saturation-factor, 1) * 87.5%), 96.9%)',
  BLUE_160: 'hsl(209, calc(var(--saturation-factor, 1) * 87.1%), 93.9%)',
  BLUE_200: 'hsl(206, calc(var(--saturation-factor, 1) * 92.3%), 89.8%)',
  BLUE_230: 'hsl(205, calc(var(--saturation-factor, 1) * 92.5%), 84.3%)',
  BLUE_260: 'hsl(204, calc(var(--saturation-factor, 1) * 94.5%), 78.4%)',
  BLUE_300: 'hsl(203, calc(var(--saturation-factor, 1) * 97.4%), 69.6%)',
  BLUE_330: 'hsl(201, calc(var(--saturation-factor, 1) * 100.0%), 59.0%)',
  BLUE_345: 'hsl(200, calc(var(--saturation-factor, 1) * 100.0%), 49.4%)',
  BLUE_360: 'hsl(203, calc(var(--saturation-factor, 1) * 100.0%), 47.5%)',
  BLUE_400: 'hsl(207, calc(var(--saturation-factor, 1) * 100.0%), 46.1%)',
  BLUE_430: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 45.3%)',
  BLUE_460: 'hsl(214, calc(var(--saturation-factor, 1) * 100.0%), 41.0%)',
  BLUE_500: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 35.7%)',
  BLUE: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 35.7%)',
  BLUE_530: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 30.4%)',
  BLUE_560: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 26.7%)',
  BLUE_600: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 23.1%)',
  BLUE_630: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 20.8%)',
  BLUE_660: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 18.6%)',
  BLUE_700: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 16.7%)',
  BLUE_730: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 14.1%)',
  BLUE_760: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 12.4%)',
  BLUE_800: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 10.6%)',
  BLUE_830: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 9.4%)',
  BLUE_860: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 8.4%)',
  BLUE_900: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 7.1%)',
  BLUE_NEW_1: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 94.3%)',
  BLUE_NEW_10: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 85.5%)',
  BLUE_NEW_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLUE_NEW_11: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 84.5%)',
  BLUE_NEW_12: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 83.5%)',
  BLUE_NEW_13: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 82.7%)',
  BLUE_NEW_14: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 82.0%)',
  BLUE_NEW_15: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 81.0%)',
  BLUE_NEW_16: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 80.2%)',
  BLUE_NEW_17: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 79.4%)',
  BLUE_NEW_18: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 78.4%)',
  BLUE_NEW_19: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 77.6%)',
  BLUE_NEW_2: 'hsl(214, calc(var(--saturation-factor, 1) * 100.0%), 93.3%)',
  BLUE_NEW_20: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 76.9%)',
  BLUE_NEW_21: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 76.1%)',
  BLUE_NEW_22: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 75.3%)',
  BLUE_NEW_23: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 74.5%)',
  BLUE_NEW_24: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 73.7%)',
  BLUE_NEW_25: 'hsl(213, calc(var(--saturation-factor, 1) * 97.1%), 72.5%)',
  BLUE_NEW_26: 'hsl(213, calc(var(--saturation-factor, 1) * 95.8%), 71.8%)',
  BLUE_NEW_27: 'hsl(213, calc(var(--saturation-factor, 1) * 94.6%), 70.8%)',
  BLUE_NEW_28: 'hsl(213, calc(var(--saturation-factor, 1) * 93.5%), 69.8%)',
  BLUE_NEW_29: 'hsl(213, calc(var(--saturation-factor, 1) * 92.5%), 68.8%)',
  BLUE_NEW_3: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 92.2%)',
  BLUE_NEW_30: 'hsl(213, calc(var(--saturation-factor, 1) * 91.4%), 68.0%)',
  BLUE_NEW_31: 'hsl(213, calc(var(--saturation-factor, 1) * 89.3%), 66.9%)',
  BLUE_NEW_32: 'hsl(213, calc(var(--saturation-factor, 1) * 88.5%), 65.9%)',
  BLUE_NEW_33: 'hsl(212, calc(var(--saturation-factor, 1) * 87.7%), 64.9%)',
  BLUE_NEW_34: 'hsl(213, calc(var(--saturation-factor, 1) * 86.9%), 64.1%)',
  BLUE_NEW_35: 'hsl(213, calc(var(--saturation-factor, 1) * 86.2%), 63.1%)',
  BLUE_NEW_36: 'hsl(213, calc(var(--saturation-factor, 1) * 84.5%), 62.0%)',
  BLUE_NEW_37: 'hsl(213, calc(var(--saturation-factor, 1) * 83.9%), 61.0%)',
  BLUE_NEW_38: 'hsl(213, calc(var(--saturation-factor, 1) * 83.3%), 60.0%)',
  BLUE_NEW_39: 'hsl(213, calc(var(--saturation-factor, 1) * 82.8%), 59.0%)',
  BLUE_NEW_4: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 91.2%)',
  BLUE_NEW_40: 'hsl(213, calc(var(--saturation-factor, 1) * 82.2%), 58.0%)',
  BLUE_NEW_41: 'hsl(213, calc(var(--saturation-factor, 1) * 81.7%), 57.1%)',
  BLUE_NEW_42: 'hsl(212, calc(var(--saturation-factor, 1) * 81.3%), 55.9%)',
  BLUE_NEW_43: 'hsl(213, calc(var(--saturation-factor, 1) * 80.9%), 54.9%)',
  BLUE_NEW_44: 'hsl(213, calc(var(--saturation-factor, 1) * 80.5%), 53.7%)',
  BLUE_NEW_45: 'hsl(212, calc(var(--saturation-factor, 1) * 80.2%), 52.4%)',
  BLUE_NEW_46: 'hsl(212, calc(var(--saturation-factor, 1) * 80.0%), 51.0%)',
  BLUE_NEW_47: 'hsl(211, calc(var(--saturation-factor, 1) * 81.7%), 49.4%)',
  BLUE_NEW_48: 'hsl(210, calc(var(--saturation-factor, 1) * 89.2%), 47.3%)',
  BLUE_NEW_49: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  BLUE_NEW_5: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 90.2%)',
  BLUE_NEW_50: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  BLUE_NEW_51: 'hsl(209, calc(var(--saturation-factor, 1) * 98.2%), 43.9%)',
  BLUE_NEW_52: 'hsl(210, calc(var(--saturation-factor, 1) * 96.4%), 43.1%)',
  BLUE_NEW_53: 'hsl(210, calc(var(--saturation-factor, 1) * 95.4%), 42.4%)',
  BLUE_NEW_54: 'hsl(210, calc(var(--saturation-factor, 1) * 94.3%), 41.6%)',
  BLUE_NEW_55: 'hsl(210, calc(var(--saturation-factor, 1) * 94.2%), 40.6%)',
  BLUE_NEW_56: 'hsl(210, calc(var(--saturation-factor, 1) * 94.1%), 39.6%)',
  BLUE_NEW_57: 'hsl(210, calc(var(--saturation-factor, 1) * 93.9%), 38.6%)',
  BLUE_NEW_58: 'hsl(209, calc(var(--saturation-factor, 1) * 93.7%), 37.6%)',
  BLUE_NEW_59: 'hsl(209, calc(var(--saturation-factor, 1) * 94.6%), 36.5%)',
  BLUE_NEW_6: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 89.2%)',
  BLUE_NEW_60: 'hsl(209, calc(var(--saturation-factor, 1) * 94.5%), 35.5%)',
  BLUE_NEW_61: 'hsl(209, calc(var(--saturation-factor, 1) * 95.5%), 34.5%)',
  BLUE_NEW_62: 'hsl(209, calc(var(--saturation-factor, 1) * 96.5%), 33.3%)',
  BLUE_NEW_63: 'hsl(209, calc(var(--saturation-factor, 1) * 97.6%), 32.4%)',
  BLUE_NEW_64: 'hsl(208, calc(var(--saturation-factor, 1) * 98.7%), 31.2%)',
  BLUE_NEW_65: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 30.2%)',
  BLUE_NEW_66: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 29.4%)',
  BLUE_NEW_67: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 28.4%)',
  BLUE_NEW_68: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 27.6%)',
  BLUE_NEW_69: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 26.9%)',
  BLUE_NEW_7: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 88.2%)',
  BLUE_NEW_70: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 26.1%)',
  BLUE_NEW_71: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 25.3%)',
  BLUE_NEW_72: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 24.5%)',
  BLUE_NEW_73: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 23.7%)',
  BLUE_NEW_74: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 22.9%)',
  BLUE_NEW_75: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 22.2%)',
  BLUE_NEW_76: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 21.4%)',
  BLUE_NEW_77: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 20.6%)',
  BLUE_NEW_78: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 19.8%)',
  BLUE_NEW_79: 'hsl(208, calc(var(--saturation-factor, 1) * 100.0%), 19.0%)',
  BLUE_NEW_8: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 87.3%)',
  BLUE_NEW_80: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 18.4%)',
  BLUE_NEW_81: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 17.6%)',
  BLUE_NEW_82: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 16.9%)',
  BLUE_NEW_83: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 16.1%)',
  BLUE_NEW_84: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 15.5%)',
  BLUE_NEW_85: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 14.7%)',
  BLUE_NEW_86: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 13.9%)',
  BLUE_NEW_87: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 13.3%)',
  BLUE_NEW_88: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 12.5%)',
  BLUE_NEW_89: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 12.0%)',
  BLUE_NEW_9: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 86.3%)',
  BLUE_NEW_90: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 11.2%)',
  BLUE_NEW_91: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 10.6%)',
  BLUE_NEW_92: 'hsl(210, calc(var(--saturation-factor, 1) * 100.0%), 9.8%)',
  BLUE_NEW_93: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 9.2%)',
  BLUE_NEW_94: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 8.4%)',
  BLUE_NEW_95: 'hsl(212, calc(var(--saturation-factor, 1) * 100.0%), 7.5%)',
  BLUE_NEW_96: 'hsl(213, calc(var(--saturation-factor, 1) * 100.0%), 6.5%)',
  BLUE_NEW_97: 'hsl(214, calc(var(--saturation-factor, 1) * 100.0%), 5.5%)',
  BLUE_NEW_98: 'hsl(217, calc(var(--saturation-factor, 1) * 100.0%), 4.1%)',
  BLUE_NEW_99: 'hsl(218, calc(var(--saturation-factor, 1) * 100.0%), 2.2%)',
  BLURPLE_1: 'hsl(231, calc(var(--saturation-factor, 1) * 100.0%), 94.9%)',
  BLURPLE_10: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 88.0%)',
  BLURPLE_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  BLURPLE_11: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 87.5%)',
  BLURPLE_12: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 86.7%)',
  BLURPLE_13: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 86.1%)',
  BLURPLE_14: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 85.3%)',
  BLURPLE_15: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 84.7%)',
  BLURPLE_16: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 84.1%)',
  BLURPLE_17: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 83.3%)',
  BLURPLE_18: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 82.7%)',
  BLURPLE_19: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 82.2%)',
  BLURPLE_2: 'hsl(230, calc(var(--saturation-factor, 1) * 100.0%), 94.1%)',
  BLURPLE_20: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 81.6%)',
  BLURPLE_21: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 81.0%)',
  BLURPLE_22: 'hsl(227, calc(var(--saturation-factor, 1) * 100.0%), 80.4%)',
  BLURPLE_23: 'hsl(227, calc(var(--saturation-factor, 1) * 100.0%), 79.8%)',
  BLURPLE_24: 'hsl(227, calc(var(--saturation-factor, 1) * 100.0%), 79.2%)',
  BLURPLE_25: 'hsl(227, calc(var(--saturation-factor, 1) * 100.0%), 78.6%)',
  BLURPLE_26: 'hsl(228, calc(var(--saturation-factor, 1) * 100.0%), 78.2%)',
  BLURPLE_27: 'hsl(228, calc(var(--saturation-factor, 1) * 100.0%), 77.6%)',
  BLURPLE_28: 'hsl(228, calc(var(--saturation-factor, 1) * 100.0%), 77.1%)',
  BLURPLE_29: 'hsl(229, calc(var(--saturation-factor, 1) * 100.0%), 76.5%)',
  BLURPLE_3: 'hsl(228, calc(var(--saturation-factor, 1) * 100.0%), 93.3%)',
  BLURPLE_30: 'hsl(229, calc(var(--saturation-factor, 1) * 100.0%), 76.1%)',
  BLURPLE_31: 'hsl(229, calc(var(--saturation-factor, 1) * 100.0%), 75.5%)',
  BLURPLE_32: 'hsl(230, calc(var(--saturation-factor, 1) * 100.0%), 75.1%)',
  BLURPLE_33: 'hsl(230, calc(var(--saturation-factor, 1) * 100.0%), 74.5%)',
  BLURPLE_34: 'hsl(230, calc(var(--saturation-factor, 1) * 98.5%), 73.7%)',
  BLURPLE_35: 'hsl(230, calc(var(--saturation-factor, 1) * 97.1%), 73.1%)',
  BLURPLE_36: 'hsl(231, calc(var(--saturation-factor, 1) * 95.7%), 72.5%)',
  BLURPLE_37: 'hsl(231, calc(var(--saturation-factor, 1) * 94.4%), 71.8%)',
  BLURPLE_38: 'hsl(231, calc(var(--saturation-factor, 1) * 93.2%), 71.2%)',
  BLURPLE_39: 'hsl(231, calc(var(--saturation-factor, 1) * 92.1%), 70.4%)',
  BLURPLE_4: 'hsl(227, calc(var(--saturation-factor, 1) * 100.0%), 92.5%)',
  BLURPLE_40: 'hsl(231, calc(var(--saturation-factor, 1) * 90.9%), 69.8%)',
  BLURPLE_41: 'hsl(232, calc(var(--saturation-factor, 1) * 89.8%), 69.2%)',
  BLURPLE_42: 'hsl(232, calc(var(--saturation-factor, 1) * 90.0%), 68.6%)',
  BLURPLE_43: 'hsl(233, calc(var(--saturation-factor, 1) * 89.0%), 68.0%)',
  BLURPLE_44: 'hsl(233, calc(var(--saturation-factor, 1) * 88.0%), 67.5%)',
  BLURPLE_45: 'hsl(233, calc(var(--saturation-factor, 1) * 87.0%), 66.9%)',
  BLURPLE_46: 'hsl(234, calc(var(--saturation-factor, 1) * 87.2%), 66.3%)',
  BLURPLE_47: 'hsl(234, calc(var(--saturation-factor, 1) * 86.3%), 65.7%)',
  BLURPLE_48: 'hsl(235, calc(var(--saturation-factor, 1) * 86.4%), 65.3%)',
  BLURPLE_49: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  BLURPLE_5: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 91.8%)',
  BLURPLE_50: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  BLURPLE_51: 'hsl(235, calc(var(--saturation-factor, 1) * 79.8%), 63.1%)',
  BLURPLE_52: 'hsl(235, calc(var(--saturation-factor, 1) * 74.5%), 61.6%)',
  BLURPLE_53: 'hsl(235, calc(var(--saturation-factor, 1) * 69.6%), 60.0%)',
  BLURPLE_54: 'hsl(234, calc(var(--saturation-factor, 1) * 65.9%), 58.6%)',
  BLURPLE_55: 'hsl(234, calc(var(--saturation-factor, 1) * 61.6%), 57.1%)',
  BLURPLE_56: 'hsl(234, calc(var(--saturation-factor, 1) * 58.4%), 55.7%)',
  BLURPLE_57: 'hsl(233, calc(var(--saturation-factor, 1) * 55.4%), 54.3%)',
  BLURPLE_58: 'hsl(233, calc(var(--saturation-factor, 1) * 52.5%), 52.9%)',
  BLURPLE_59: 'hsl(233, calc(var(--saturation-factor, 1) * 49.2%), 51.4%)',
  BLURPLE_6: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 91.0%)',
  BLURPLE_60: 'hsl(233, calc(var(--saturation-factor, 1) * 46.7%), 50.0%)',
  BLURPLE_61: 'hsl(233, calc(var(--saturation-factor, 1) * 46.8%), 48.6%)',
  BLURPLE_62: 'hsl(233, calc(var(--saturation-factor, 1) * 47.1%), 47.5%)',
  BLURPLE_63: 'hsl(232, calc(var(--saturation-factor, 1) * 47.2%), 46.1%)',
  BLURPLE_64: 'hsl(232, calc(var(--saturation-factor, 1) * 47.4%), 44.7%)',
  BLURPLE_65: 'hsl(232, calc(var(--saturation-factor, 1) * 47.5%), 43.3%)',
  BLURPLE_66: 'hsl(232, calc(var(--saturation-factor, 1) * 47.9%), 42.2%)',
  BLURPLE_67: 'hsl(232, calc(var(--saturation-factor, 1) * 48.1%), 40.8%)',
  BLURPLE_68: 'hsl(231, calc(var(--saturation-factor, 1) * 48.5%), 39.6%)',
  BLURPLE_69: 'hsl(231, calc(var(--saturation-factor, 1) * 48.7%), 38.2%)',
  BLURPLE_7: 'hsl(226, calc(var(--saturation-factor, 1) * 100.0%), 90.2%)',
  BLURPLE_70: 'hsl(231, calc(var(--saturation-factor, 1) * 49.2%), 37.1%)',
  BLURPLE_71: 'hsl(231, calc(var(--saturation-factor, 1) * 49.7%), 35.9%)',
  BLURPLE_72: 'hsl(230, calc(var(--saturation-factor, 1) * 50.0%), 34.5%)',
  BLURPLE_73: 'hsl(230, calc(var(--saturation-factor, 1) * 50.6%), 33.3%)',
  BLURPLE_74: 'hsl(230, calc(var(--saturation-factor, 1) * 51.2%), 32.2%)',
  BLURPLE_75: 'hsl(230, calc(var(--saturation-factor, 1) * 50.9%), 31.2%)',
  BLURPLE_76: 'hsl(229, calc(var(--saturation-factor, 1) * 51.3%), 29.8%)',
  BLURPLE_77: 'hsl(229, calc(var(--saturation-factor, 1) * 52.1%), 28.6%)',
  BLURPLE_78: 'hsl(229, calc(var(--saturation-factor, 1) * 52.9%), 27.5%)',
  BLURPLE_79: 'hsl(228, calc(var(--saturation-factor, 1) * 53.7%), 26.3%)',
  BLURPLE_8: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 89.6%)',
  BLURPLE_80: 'hsl(228, calc(var(--saturation-factor, 1) * 54.7%), 25.1%)',
  BLURPLE_81: 'hsl(228, calc(var(--saturation-factor, 1) * 54.5%), 24.1%)',
  BLURPLE_82: 'hsl(228, calc(var(--saturation-factor, 1) * 55.6%), 22.9%)',
  BLURPLE_83: 'hsl(228, calc(var(--saturation-factor, 1) * 57.1%), 22.0%)',
  BLURPLE_84: 'hsl(227, calc(var(--saturation-factor, 1) * 57.0%), 21.0%)',
  BLURPLE_85: 'hsl(227, calc(var(--saturation-factor, 1) * 58.4%), 19.8%)',
  BLURPLE_86: 'hsl(226, calc(var(--saturation-factor, 1) * 60.0%), 18.6%)',
  BLURPLE_87: 'hsl(227, calc(var(--saturation-factor, 1) * 60.0%), 17.6%)',
  BLURPLE_88: 'hsl(226, calc(var(--saturation-factor, 1) * 62.4%), 16.7%)',
  BLURPLE_89: 'hsl(227, calc(var(--saturation-factor, 1) * 62.5%), 15.7%)',
  BLURPLE_9: 'hsl(225, calc(var(--saturation-factor, 1) * 100.0%), 88.8%)',
  BLURPLE_90: 'hsl(225, calc(var(--saturation-factor, 1) * 64.9%), 14.5%)',
  BLURPLE_91: 'hsl(226, calc(var(--saturation-factor, 1) * 65.7%), 13.7%)',
  BLURPLE_92: 'hsl(225, calc(var(--saturation-factor, 1) * 68.8%), 12.5%)',
  BLURPLE_93: 'hsl(225, calc(var(--saturation-factor, 1) * 69.5%), 11.6%)',
  BLURPLE_94: 'hsl(225, calc(var(--saturation-factor, 1) * 73.6%), 10.4%)',
  BLURPLE_95: 'hsl(225, calc(var(--saturation-factor, 1) * 74.5%), 9.2%)',
  BLURPLE_96: 'hsl(225, calc(var(--saturation-factor, 1) * 75.6%), 8.0%)',
  BLURPLE_97: 'hsl(226, calc(var(--saturation-factor, 1) * 76.5%), 6.7%)',
  BLURPLE_98: 'hsl(227, calc(var(--saturation-factor, 1) * 76.0%), 4.9%)',
  BLURPLE_99: 'hsl(229, calc(var(--saturation-factor, 1) * 84.6%), 2.5%)',
  BRAND_100: 'hsl(240, calc(var(--saturation-factor, 1) * 77.8%), 98.2%)',
  BRAND_130: 'hsl(236, calc(var(--saturation-factor, 1) * 87.5%), 96.9%)',
  BRAND_160: 'hsl(235, calc(var(--saturation-factor, 1) * 84.6%), 94.9%)',
  BRAND_200: 'hsl(236, calc(var(--saturation-factor, 1) * 83.3%), 92.9%)',
  BRAND_230: 'hsl(236, calc(var(--saturation-factor, 1) * 87.0%), 91.0%)',
  BRAND_260: 'hsl(235, calc(var(--saturation-factor, 1) * 86.2%), 88.6%)',
  BRAND_300: 'hsl(235, calc(var(--saturation-factor, 1) * 86.1%), 85.9%)',
  BRAND_330: 'hsl(235, calc(var(--saturation-factor, 1) * 85.1%), 81.6%)',
  BRAND_345: 'hsl(235, calc(var(--saturation-factor, 1) * 85.2%), 78.8%)',
  BRAND_360: 'hsl(235, calc(var(--saturation-factor, 1) * 86.1%), 77.5%)',
  BRAND_400: 'hsl(235, calc(var(--saturation-factor, 1) * 86.1%), 71.8%)',
  BRAND_430: 'hsl(235, calc(var(--saturation-factor, 1) * 85.7%), 69.8%)',
  BRAND_460: 'hsl(235, calc(var(--saturation-factor, 1) * 85.5%), 67.5%)',
  BRAND_500: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  BRAND: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  BRAND_530: 'hsl(235, calc(var(--saturation-factor, 1) * 66.7%), 58.8%)',
  BRAND_560: 'hsl(235, calc(var(--saturation-factor, 1) * 51.4%), 52.4%)',
  BRAND_600: 'hsl(235, calc(var(--saturation-factor, 1) * 46.7%), 44.1%)',
  BRAND_630: 'hsl(235, calc(var(--saturation-factor, 1) * 46.7%), 38.2%)',
  BRAND_660: 'hsl(235, calc(var(--saturation-factor, 1) * 47.1%), 33.3%)',
  BRAND_700: 'hsl(235, calc(var(--saturation-factor, 1) * 47.0%), 25.9%)',
  BRAND_730: 'hsl(235, calc(var(--saturation-factor, 1) * 46.8%), 24.3%)',
  BRAND_760: 'hsl(234, calc(var(--saturation-factor, 1) * 46.9%), 22.2%)',
  BRAND_800: 'hsl(235, calc(var(--saturation-factor, 1) * 47.5%), 19.4%)',
  BRAND_830: 'hsl(235, calc(var(--saturation-factor, 1) * 47.4%), 14.9%)',
  BRAND_860: 'hsl(235, calc(var(--saturation-factor, 1) * 46.9%), 9.6%)',
  BRAND_900: 'hsl(233, calc(var(--saturation-factor, 1) * 50.0%), 3.1%)',
  BUNGIE: 'hsl(197, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  CRUNCHYROLL: 'hsl(29, calc(var(--saturation-factor, 1) * 93.0%), 55.5%)',
  EBAY: 'hsl(211, calc(var(--saturation-factor, 1) * 100.0%), 41.2%)',
  EPIC_GAMES: 'hsl(34, calc(var(--saturation-factor, 1) * 6.2%), 22.2%)',
  FACEBOOK: 'hsl(221, calc(var(--saturation-factor, 1) * 44.2%), 37.3%)',
  GITHUB: 'hsl(0, calc(var(--saturation-factor, 1) * 4.2%), 9.4%)',
  GOLD: 'hsl(46, calc(var(--saturation-factor, 1) * 100.0%), 54.9%)',
  GREEN_100: 'hsl(137, calc(var(--saturation-factor, 1) * 90.0%), 96.1%)',
  GREEN_130: 'hsl(137, calc(var(--saturation-factor, 1) * 94.1%), 93.3%)',
  GREEN_160: 'hsl(141, calc(var(--saturation-factor, 1) * 91.3%), 86.5%)',
  GREEN_200: 'hsl(143, calc(var(--saturation-factor, 1) * 93.5%), 75.9%)',
  GREEN_230: 'hsl(146, calc(var(--saturation-factor, 1) * 86.6%), 64.9%)',
  GREEN_260: 'hsl(146, calc(var(--saturation-factor, 1) * 75.1%), 59.0%)',
  GREEN_300: 'hsl(146, calc(var(--saturation-factor, 1) * 65.4%), 53.5%)',
  GREEN_330: 'hsl(146, calc(var(--saturation-factor, 1) * 63.1%), 47.8%)',
  GREEN_345: 'hsl(147, calc(var(--saturation-factor, 1) * 65.9%), 43.7%)',
  GREEN_360: 'hsl(145, calc(var(--saturation-factor, 1) * 65.0%), 39.2%)',
  GREEN_400: 'hsl(143, calc(var(--saturation-factor, 1) * 60.7%), 35.9%)',
  GREEN_430: 'hsl(142, calc(var(--saturation-factor, 1) * 56.1%), 32.2%)',
  GREEN_460: 'hsl(141, calc(var(--saturation-factor, 1) * 56.6%), 28.0%)',
  GREEN_500: 'hsl(141, calc(var(--saturation-factor, 1) * 58.4%), 24.5%)',
  GREEN: 'hsl(141, calc(var(--saturation-factor, 1) * 58.4%), 24.5%)',
  GREEN_530: 'hsl(140, calc(var(--saturation-factor, 1) * 60.7%), 21.0%)',
  GREEN_560: 'hsl(139, calc(var(--saturation-factor, 1) * 61.7%), 18.4%)',
  GREEN_600: 'hsl(139, calc(var(--saturation-factor, 1) * 65.4%), 15.9%)',
  GREEN_630: 'hsl(140, calc(var(--saturation-factor, 1) * 66.7%), 14.1%)',
  GREEN_660: 'hsl(139, calc(var(--saturation-factor, 1) * 68.8%), 12.5%)',
  GREEN_700: 'hsl(141, calc(var(--saturation-factor, 1) * 74.1%), 10.6%)',
  GREEN_730: 'hsl(138, calc(var(--saturation-factor, 1) * 78.3%), 9.0%)',
  GREEN_760: 'hsl(140, calc(var(--saturation-factor, 1) * 84.6%), 7.6%)',
  GREEN_800: 'hsl(139, calc(var(--saturation-factor, 1) * 82.4%), 6.7%)',
  GREEN_830: 'hsl(138, calc(var(--saturation-factor, 1) * 80.0%), 5.9%)',
  GREEN_860: 'hsl(133, calc(var(--saturation-factor, 1) * 70.4%), 5.3%)',
  GREEN_900: 'hsl(129, calc(var(--saturation-factor, 1) * 58.3%), 4.7%)',
  GREEN_NEW_1: 'hsl(133, calc(var(--saturation-factor, 1) * 100.0%), 86.9%)',
  GREEN_NEW_10: 'hsl(130, calc(var(--saturation-factor, 1) * 69.5%), 76.9%)',
  GREEN_NEW_100: 'hsl(129, calc(var(--saturation-factor, 1) * 100.0%), 1.4%)',
  GREEN_NEW_11: 'hsl(130, calc(var(--saturation-factor, 1) * 66.1%), 75.7%)',
  GREEN_NEW_12: 'hsl(130, calc(var(--saturation-factor, 1) * 64.3%), 74.7%)',
  GREEN_NEW_13: 'hsl(131, calc(var(--saturation-factor, 1) * 61.8%), 73.3%)',
  GREEN_NEW_14: 'hsl(130, calc(var(--saturation-factor, 1) * 59.2%), 72.2%)',
  GREEN_NEW_15: 'hsl(130, calc(var(--saturation-factor, 1) * 57.8%), 71.2%)',
  GREEN_NEW_16: 'hsl(130, calc(var(--saturation-factor, 1) * 55.6%), 70.0%)',
  GREEN_NEW_17: 'hsl(130, calc(var(--saturation-factor, 1) * 53.7%), 68.6%)',
  GREEN_NEW_18: 'hsl(130, calc(var(--saturation-factor, 1) * 51.8%), 67.5%)',
  GREEN_NEW_19: 'hsl(130, calc(var(--saturation-factor, 1) * 50.9%), 66.5%)',
  GREEN_NEW_2: 'hsl(132, calc(var(--saturation-factor, 1) * 100.0%), 86.1%)',
  GREEN_NEW_20: 'hsl(130, calc(var(--saturation-factor, 1) * 49.2%), 65.3%)',
  GREEN_NEW_21: 'hsl(130, calc(var(--saturation-factor, 1) * 47.5%), 64.1%)',
  GREEN_NEW_22: 'hsl(131, calc(var(--saturation-factor, 1) * 46.8%), 63.1%)',
  GREEN_NEW_23: 'hsl(131, calc(var(--saturation-factor, 1) * 45.6%), 61.8%)',
  GREEN_NEW_24: 'hsl(131, calc(var(--saturation-factor, 1) * 44.3%), 60.6%)',
  GREEN_NEW_25: 'hsl(131, calc(var(--saturation-factor, 1) * 43.0%), 59.4%)',
  GREEN_NEW_26: 'hsl(131, calc(var(--saturation-factor, 1) * 42.5%), 58.4%)',
  GREEN_NEW_27: 'hsl(131, calc(var(--saturation-factor, 1) * 41.3%), 57.3%)',
  GREEN_NEW_28: 'hsl(132, calc(var(--saturation-factor, 1) * 40.2%), 56.1%)',
  GREEN_NEW_29: 'hsl(132, calc(var(--saturation-factor, 1) * 40.0%), 54.9%)',
  GREEN_NEW_3: 'hsl(131, calc(var(--saturation-factor, 1) * 100.0%), 85.3%)',
  GREEN_NEW_30: 'hsl(132, calc(var(--saturation-factor, 1) * 39.0%), 53.7%)',
  GREEN_NEW_31: 'hsl(132, calc(var(--saturation-factor, 1) * 38.0%), 52.5%)',
  GREEN_NEW_32: 'hsl(133, calc(var(--saturation-factor, 1) * 37.7%), 51.6%)',
  GREEN_NEW_33: 'hsl(133, calc(var(--saturation-factor, 1) * 36.8%), 50.4%)',
  GREEN_NEW_34: 'hsl(133, calc(var(--saturation-factor, 1) * 37.6%), 49.0%)',
  GREEN_NEW_35: 'hsl(134, calc(var(--saturation-factor, 1) * 38.8%), 48.0%)',
  GREEN_NEW_36: 'hsl(134, calc(var(--saturation-factor, 1) * 40.3%), 46.7%)',
  GREEN_NEW_37: 'hsl(134, calc(var(--saturation-factor, 1) * 41.6%), 45.7%)',
  GREEN_NEW_38: 'hsl(135, calc(var(--saturation-factor, 1) * 43.4%), 44.3%)',
  GREEN_NEW_39: 'hsl(136, calc(var(--saturation-factor, 1) * 45.2%), 42.9%)',
  GREEN_NEW_4: 'hsl(130, calc(var(--saturation-factor, 1) * 95.0%), 84.3%)',
  GREEN_NEW_40: 'hsl(136, calc(var(--saturation-factor, 1) * 46.7%), 42.0%)',
  GREEN_NEW_41: 'hsl(136, calc(var(--saturation-factor, 1) * 48.8%), 40.6%)',
  GREEN_NEW_42: 'hsl(137, calc(var(--saturation-factor, 1) * 52.0%), 39.2%)',
  GREEN_NEW_43: 'hsl(138, calc(var(--saturation-factor, 1) * 54.4%), 37.8%)',
  GREEN_NEW_44: 'hsl(138, calc(var(--saturation-factor, 1) * 58.1%), 36.5%)',
  GREEN_NEW_45: 'hsl(139, calc(var(--saturation-factor, 1) * 61.8%), 34.9%)',
  GREEN_NEW_46: 'hsl(140, calc(var(--saturation-factor, 1) * 67.1%), 33.3%)',
  GREEN_NEW_47: 'hsl(142, calc(var(--saturation-factor, 1) * 73.7%), 31.4%)',
  GREEN_NEW_48: 'hsl(144, calc(var(--saturation-factor, 1) * 83.8%), 29.0%)',
  GREEN_NEW_49: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  GREEN_NEW_5: 'hsl(131, calc(var(--saturation-factor, 1) * 88.5%), 82.9%)',
  GREEN_NEW_50: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  GREEN_NEW_51: 'hsl(146, calc(var(--saturation-factor, 1) * 97.0%), 26.1%)',
  GREEN_NEW_52: 'hsl(145, calc(var(--saturation-factor, 1) * 95.5%), 25.9%)',
  GREEN_NEW_53: 'hsl(145, calc(var(--saturation-factor, 1) * 93.8%), 25.5%)',
  GREEN_NEW_54: 'hsl(145, calc(var(--saturation-factor, 1) * 93.7%), 24.9%)',
  GREEN_NEW_55: 'hsl(145, calc(var(--saturation-factor, 1) * 92.0%), 24.5%)',
  GREEN_NEW_56: 'hsl(144, calc(var(--saturation-factor, 1) * 91.9%), 24.1%)',
  GREEN_NEW_57: 'hsl(145, calc(var(--saturation-factor, 1) * 91.7%), 23.5%)',
  GREEN_NEW_58: 'hsl(145, calc(var(--saturation-factor, 1) * 93.1%), 22.7%)',
  GREEN_NEW_59: 'hsl(144, calc(var(--saturation-factor, 1) * 93.0%), 22.4%)',
  GREEN_NEW_6: 'hsl(131, calc(var(--saturation-factor, 1) * 84.9%), 81.8%)',
  GREEN_NEW_60: 'hsl(144, calc(var(--saturation-factor, 1) * 92.8%), 21.8%)',
  GREEN_NEW_61: 'hsl(145, calc(var(--saturation-factor, 1) * 94.4%), 21.2%)',
  GREEN_NEW_62: 'hsl(145, calc(var(--saturation-factor, 1) * 96.2%), 20.4%)',
  GREEN_NEW_63: 'hsl(144, calc(var(--saturation-factor, 1) * 96.1%), 20.0%)',
  GREEN_NEW_64: 'hsl(145, calc(var(--saturation-factor, 1) * 98.0%), 19.2%)',
  GREEN_NEW_65: 'hsl(145, calc(var(--saturation-factor, 1) * 100.0%), 18.4%)',
  GREEN_NEW_66: 'hsl(145, calc(var(--saturation-factor, 1) * 100.0%), 18.0%)',
  GREEN_NEW_67: 'hsl(145, calc(var(--saturation-factor, 1) * 100.0%), 17.5%)',
  GREEN_NEW_68: 'hsl(144, calc(var(--saturation-factor, 1) * 100.0%), 17.1%)',
  GREEN_NEW_69: 'hsl(144, calc(var(--saturation-factor, 1) * 100.0%), 16.7%)',
  GREEN_NEW_7: 'hsl(131, calc(var(--saturation-factor, 1) * 79.8%), 80.6%)',
  GREEN_NEW_70: 'hsl(144, calc(var(--saturation-factor, 1) * 100.0%), 16.1%)',
  GREEN_NEW_71: 'hsl(143, calc(var(--saturation-factor, 1) * 100.0%), 15.7%)',
  GREEN_NEW_72: 'hsl(143, calc(var(--saturation-factor, 1) * 100.0%), 15.1%)',
  GREEN_NEW_73: 'hsl(142, calc(var(--saturation-factor, 1) * 100.0%), 14.7%)',
  GREEN_NEW_74: 'hsl(143, calc(var(--saturation-factor, 1) * 100.0%), 14.1%)',
  GREEN_NEW_75: 'hsl(142, calc(var(--saturation-factor, 1) * 100.0%), 13.7%)',
  GREEN_NEW_76: 'hsl(141, calc(var(--saturation-factor, 1) * 100.0%), 13.3%)',
  GREEN_NEW_77: 'hsl(141, calc(var(--saturation-factor, 1) * 100.0%), 12.7%)',
  GREEN_NEW_78: 'hsl(141, calc(var(--saturation-factor, 1) * 100.0%), 12.4%)',
  GREEN_NEW_79: 'hsl(140, calc(var(--saturation-factor, 1) * 100.0%), 12.0%)',
  GREEN_NEW_8: 'hsl(131, calc(var(--saturation-factor, 1) * 75.5%), 79.2%)',
  GREEN_NEW_80: 'hsl(140, calc(var(--saturation-factor, 1) * 100.0%), 11.4%)',
  GREEN_NEW_81: 'hsl(139, calc(var(--saturation-factor, 1) * 100.0%), 11.0%)',
  GREEN_NEW_82: 'hsl(139, calc(var(--saturation-factor, 1) * 100.0%), 10.6%)',
  GREEN_NEW_83: 'hsl(137, calc(var(--saturation-factor, 1) * 100.0%), 10.2%)',
  GREEN_NEW_84: 'hsl(137, calc(var(--saturation-factor, 1) * 100.0%), 9.6%)',
  GREEN_NEW_85: 'hsl(137, calc(var(--saturation-factor, 1) * 100.0%), 9.2%)',
  GREEN_NEW_86: 'hsl(136, calc(var(--saturation-factor, 1) * 100.0%), 8.8%)',
  GREEN_NEW_87: 'hsl(135, calc(var(--saturation-factor, 1) * 100.0%), 8.4%)',
  GREEN_NEW_88: 'hsl(134, calc(var(--saturation-factor, 1) * 100.0%), 7.8%)',
  GREEN_NEW_89: 'hsl(133, calc(var(--saturation-factor, 1) * 100.0%), 7.5%)',
  GREEN_NEW_9: 'hsl(130, calc(var(--saturation-factor, 1) * 73.0%), 78.2%)',
  GREEN_NEW_90: 'hsl(132, calc(var(--saturation-factor, 1) * 100.0%), 7.1%)',
  GREEN_NEW_91: 'hsl(132, calc(var(--saturation-factor, 1) * 100.0%), 6.7%)',
  GREEN_NEW_92: 'hsl(131, calc(var(--saturation-factor, 1) * 100.0%), 6.3%)',
  GREEN_NEW_93: 'hsl(130, calc(var(--saturation-factor, 1) * 100.0%), 5.9%)',
  GREEN_NEW_94: 'hsl(129, calc(var(--saturation-factor, 1) * 100.0%), 5.3%)',
  GREEN_NEW_95: 'hsl(130, calc(var(--saturation-factor, 1) * 100.0%), 4.9%)',
  GREEN_NEW_96: 'hsl(128, calc(var(--saturation-factor, 1) * 100.0%), 4.3%)',
  GREEN_NEW_97: 'hsl(129, calc(var(--saturation-factor, 1) * 100.0%), 3.9%)',
  GREEN_NEW_98: 'hsl(128, calc(var(--saturation-factor, 1) * 100.0%), 3.1%)',
  GREEN_NEW_99: 'hsl(130, calc(var(--saturation-factor, 1) * 100.0%), 2.4%)',
  GUILD_BOOSTING_BLUE: 'hsl(221, calc(var(--saturation-factor, 1) * 70.0%), 55.5%)',
  GUILD_BOOSTING_BLUE_FOR_GRADIENTS: 'hsl(235, calc(var(--saturation-factor, 1) * 68.5%), 52.7%)',
  GUILD_BOOSTING_PINK: 'hsl(302, calc(var(--saturation-factor, 1) * 100.0%), 72.5%)',
  GUILD_BOOSTING_PURPLE: 'hsl(269, calc(var(--saturation-factor, 1) * 83.8%), 71.0%)',
  GUILD_BOOSTING_PURPLE_FOR_GRADIENTS: 'hsl(269, calc(var(--saturation-factor, 1) * 91.8%), 61.8%)',
  HYPESQUAD_HOUSE_1: 'hsl(253, calc(var(--saturation-factor, 1) * 77.0%), 72.7%)',
  HYPESQUAD_HOUSE_2: 'hsl(9, calc(var(--saturation-factor, 1) * 86.5%), 68.0%)',
  HYPESQUAD_HOUSE_3: 'hsl(169, calc(var(--saturation-factor, 1) * 69.1%), 56.9%)',
  INPUT_PLACEHOLDER_TEXT_DARK: 'hsl(216, calc(var(--saturation-factor, 1) * 2.1%), 53.9%)',
  LOL: 'hsl(190, calc(var(--saturation-factor, 1) * 89.7%), 7.6%)',
  LOL_TEXT_DARK: 'hsl(37, calc(var(--saturation-factor, 1) * 81.6%), 32.0%)',
  LOL_TEXT_LIGHT: 'hsl(41, calc(var(--saturation-factor, 1) * 50.2%), 59.0%)',
  NEUTRAL_1: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  NEUTRAL_10: 'hsl(225, calc(var(--saturation-factor, 1) * 5.9%), 86.7%)',
  NEUTRAL_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  NEUTRAL_11: 'hsl(225, calc(var(--saturation-factor, 1) * 5.3%), 85.1%)',
  NEUTRAL_12: 'hsl(225, calc(var(--saturation-factor, 1) * 4.8%), 83.5%)',
  NEUTRAL_13: 'hsl(240, calc(var(--saturation-factor, 1) * 4.4%), 82.4%)',
  NEUTRAL_14: 'hsl(240, calc(var(--saturation-factor, 1) * 4.1%), 80.8%)',
  NEUTRAL_15: 'hsl(240, calc(var(--saturation-factor, 1) * 4.8%), 79.4%)',
  NEUTRAL_16: 'hsl(228, calc(var(--saturation-factor, 1) * 4.4%), 77.8%)',
  NEUTRAL_17: 'hsl(230, calc(var(--saturation-factor, 1) * 5.0%), 76.5%)',
  NEUTRAL_18: 'hsl(230, calc(var(--saturation-factor, 1) * 4.7%), 74.9%)',
  NEUTRAL_19: 'hsl(240, calc(var(--saturation-factor, 1) * 4.5%), 73.7%)',
  NEUTRAL_2: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 98.4%)',
  NEUTRAL_20: 'hsl(230, calc(var(--saturation-factor, 1) * 4.2%), 72.2%)',
  NEUTRAL_21: 'hsl(231, calc(var(--saturation-factor, 1) * 4.7%), 70.8%)',
  NEUTRAL_22: 'hsl(231, calc(var(--saturation-factor, 1) * 4.5%), 69.2%)',
  NEUTRAL_23: 'hsl(240, calc(var(--saturation-factor, 1) * 4.3%), 68.0%)',
  NEUTRAL_24: 'hsl(231, calc(var(--saturation-factor, 1) * 4.1%), 66.5%)',
  NEUTRAL_25: 'hsl(233, calc(var(--saturation-factor, 1) * 4.5%), 65.1%)',
  NEUTRAL_26: 'hsl(240, calc(var(--saturation-factor, 1) * 3.8%), 63.7%)',
  NEUTRAL_27: 'hsl(232, calc(var(--saturation-factor, 1) * 4.2%), 62.4%)',
  NEUTRAL_28: 'hsl(233, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  NEUTRAL_29: 'hsl(233, calc(var(--saturation-factor, 1) * 3.9%), 59.6%)',
  NEUTRAL_3: 'hsl(240, calc(var(--saturation-factor, 1) * 6.7%), 97.1%)',
  NEUTRAL_30: 'hsl(233, calc(var(--saturation-factor, 1) * 4.2%), 58.2%)',
  NEUTRAL_31: 'hsl(233, calc(var(--saturation-factor, 1) * 4.1%), 56.7%)',
  NEUTRAL_32: 'hsl(233, calc(var(--saturation-factor, 1) * 4.0%), 55.5%)',
  NEUTRAL_33: 'hsl(233, calc(var(--saturation-factor, 1) * 3.8%), 53.9%)',
  NEUTRAL_34: 'hsl(233, calc(var(--saturation-factor, 1) * 3.7%), 52.7%)',
  NEUTRAL_35: 'hsl(234, calc(var(--saturation-factor, 1) * 4.0%), 51.4%)',
  NEUTRAL_36: 'hsl(233, calc(var(--saturation-factor, 1) * 3.5%), 50.0%)',
  NEUTRAL_37: 'hsl(234, calc(var(--saturation-factor, 1) * 4.0%), 48.6%)',
  NEUTRAL_38: 'hsl(234, calc(var(--saturation-factor, 1) * 4.1%), 47.5%)',
  NEUTRAL_39: 'hsl(234, calc(var(--saturation-factor, 1) * 4.3%), 45.9%)',
  NEUTRAL_4: 'hsl(240, calc(var(--saturation-factor, 1) * 4.3%), 95.5%)',
  NEUTRAL_40: 'hsl(234, calc(var(--saturation-factor, 1) * 4.4%), 44.7%)',
  NEUTRAL_41: 'hsl(234, calc(var(--saturation-factor, 1) * 4.5%), 43.5%)',
  NEUTRAL_42: 'hsl(235, calc(var(--saturation-factor, 1) * 5.1%), 42.2%)',
  NEUTRAL_43: 'hsl(234, calc(var(--saturation-factor, 1) * 4.8%), 40.8%)',
  NEUTRAL_44: 'hsl(235, calc(var(--saturation-factor, 1) * 5.5%), 39.4%)',
  NEUTRAL_45: 'hsl(235, calc(var(--saturation-factor, 1) * 5.6%), 38.2%)',
  NEUTRAL_46: 'hsl(235, calc(var(--saturation-factor, 1) * 5.8%), 37.1%)',
  NEUTRAL_47: 'hsl(229, calc(var(--saturation-factor, 1) * 6.1%), 35.5%)',
  NEUTRAL_48: 'hsl(235, calc(var(--saturation-factor, 1) * 6.3%), 34.3%)',
  NEUTRAL_49: 'hsl(235, calc(var(--saturation-factor, 1) * 6.5%), 33.1%)',
  NEUTRAL_5: 'hsl(240, calc(var(--saturation-factor, 1) * 3.2%), 93.9%)',
  NEUTRAL_50: 'hsl(235, calc(var(--saturation-factor, 1) * 6.5%), 33.1%)',
  NEUTRAL_51: 'hsl(235, calc(var(--saturation-factor, 1) * 6.7%), 32.4%)',
  NEUTRAL_52: 'hsl(234, calc(var(--saturation-factor, 1) * 6.2%), 31.8%)',
  NEUTRAL_53: 'hsl(235, calc(var(--saturation-factor, 1) * 6.9%), 31.2%)',
  NEUTRAL_54: 'hsl(234, calc(var(--saturation-factor, 1) * 6.4%), 30.6%)',
  NEUTRAL_55: 'hsl(234, calc(var(--saturation-factor, 1) * 6.6%), 29.8%)',
  NEUTRAL_56: 'hsl(233, calc(var(--saturation-factor, 1) * 6.0%), 29.2%)',
  NEUTRAL_57: 'hsl(233, calc(var(--saturation-factor, 1) * 6.2%), 28.4%)',
  NEUTRAL_58: 'hsl(240, calc(var(--saturation-factor, 1) * 6.3%), 28.0%)',
  NEUTRAL_59: 'hsl(233, calc(var(--saturation-factor, 1) * 6.5%), 27.3%)',
  NEUTRAL_6: 'hsl(240, calc(var(--saturation-factor, 1) * 5.3%), 92.5%)',
  NEUTRAL_60: 'hsl(233, calc(var(--saturation-factor, 1) * 6.7%), 26.5%)',
  NEUTRAL_61: 'hsl(232, calc(var(--saturation-factor, 1) * 6.1%), 25.9%)',
  NEUTRAL_62: 'hsl(233, calc(var(--saturation-factor, 1) * 7.0%), 25.3%)',
  NEUTRAL_63: 'hsl(233, calc(var(--saturation-factor, 1) * 6.3%), 24.7%)',
  NEUTRAL_64: 'hsl(233, calc(var(--saturation-factor, 1) * 6.6%), 23.9%)',
  NEUTRAL_65: 'hsl(232, calc(var(--saturation-factor, 1) * 6.7%), 23.5%)',
  NEUTRAL_66: 'hsl(232, calc(var(--saturation-factor, 1) * 6.9%), 22.7%)',
  NEUTRAL_67: 'hsl(231, calc(var(--saturation-factor, 1) * 6.2%), 22.2%)',
  NEUTRAL_68: 'hsl(240, calc(var(--saturation-factor, 1) * 5.5%), 21.6%)',
  NEUTRAL_69: 'hsl(231, calc(var(--saturation-factor, 1) * 6.5%), 21.0%)',
  NEUTRAL_7: 'hsl(240, calc(var(--saturation-factor, 1) * 4.3%), 91.0%)',
  NEUTRAL_70: 'hsl(240, calc(var(--saturation-factor, 1) * 5.8%), 20.4%)',
  NEUTRAL_71: 'hsl(230, calc(var(--saturation-factor, 1) * 6.0%), 19.6%)',
  NEUTRAL_72: 'hsl(240, calc(var(--saturation-factor, 1) * 6.1%), 19.2%)',
  NEUTRAL_73: 'hsl(230, calc(var(--saturation-factor, 1) * 6.4%), 18.4%)',
  NEUTRAL_74: 'hsl(240, calc(var(--saturation-factor, 1) * 6.5%), 18.0%)',
  NEUTRAL_75: 'hsl(230, calc(var(--saturation-factor, 1) * 6.8%), 17.3%)',
  NEUTRAL_76: 'hsl(240, calc(var(--saturation-factor, 1) * 5.9%), 16.7%)',
  NEUTRAL_77: 'hsl(240, calc(var(--saturation-factor, 1) * 6.0%), 16.3%)',
  NEUTRAL_78: 'hsl(228, calc(var(--saturation-factor, 1) * 6.3%), 15.5%)',
  NEUTRAL_79: 'hsl(240, calc(var(--saturation-factor, 1) * 6.5%), 15.1%)',
  NEUTRAL_8: 'hsl(240, calc(var(--saturation-factor, 1) * 5.7%), 89.6%)',
  NEUTRAL_80: 'hsl(228, calc(var(--saturation-factor, 1) * 6.8%), 14.3%)',
  NEUTRAL_81: 'hsl(240, calc(var(--saturation-factor, 1) * 5.7%), 13.7%)',
  NEUTRAL_82: 'hsl(240, calc(var(--saturation-factor, 1) * 5.9%), 13.3%)',
  NEUTRAL_83: 'hsl(225, calc(var(--saturation-factor, 1) * 6.3%), 12.5%)',
  NEUTRAL_84: 'hsl(240, calc(var(--saturation-factor, 1) * 6.5%), 12.2%)',
  NEUTRAL_85: 'hsl(225, calc(var(--saturation-factor, 1) * 6.9%), 11.4%)',
  NEUTRAL_86: 'hsl(240, calc(var(--saturation-factor, 1) * 7.1%), 11.0%)',
  NEUTRAL_87: 'hsl(240, calc(var(--saturation-factor, 1) * 5.7%), 10.4%)',
  NEUTRAL_88: 'hsl(225, calc(var(--saturation-factor, 1) * 8.0%), 9.8%)',
  NEUTRAL_89: 'hsl(240, calc(var(--saturation-factor, 1) * 6.4%), 9.2%)',
  NEUTRAL_9: 'hsl(220, calc(var(--saturation-factor, 1) * 4.9%), 88.0%)',
  NEUTRAL_90: 'hsl(240, calc(var(--saturation-factor, 1) * 6.7%), 8.8%)',
  NEUTRAL_91: 'hsl(220, calc(var(--saturation-factor, 1) * 7.3%), 8.0%)',
  NEUTRAL_92: 'hsl(240, calc(var(--saturation-factor, 1) * 5.3%), 7.5%)',
  NEUTRAL_93: 'hsl(240, calc(var(--saturation-factor, 1) * 8.6%), 6.9%)',
  NEUTRAL_94: 'hsl(240, calc(var(--saturation-factor, 1) * 6.7%), 5.9%)',
  NEUTRAL_95: 'hsl(240, calc(var(--saturation-factor, 1) * 7.7%), 5.1%)',
  NEUTRAL_96: 'hsl(240, calc(var(--saturation-factor, 1) * 9.1%), 4.3%)',
  NEUTRAL_97: 'hsl(240, calc(var(--saturation-factor, 1) * 12.5%), 3.1%)',
  NEUTRAL_98: 'hsl(240, calc(var(--saturation-factor, 1) * 9.1%), 2.2%)',
  NEUTRAL_99: 'hsl(240, calc(var(--saturation-factor, 1) * 20.0%), 1.0%)',
  OPACITY_1: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_12: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_16: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_20: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_24: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_28: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_32: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_36: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_4: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_40: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_44: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_48: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_52: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_56: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_60: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_64: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_68: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_72: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_76: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_8: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_80: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_84: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_88: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_92: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_96: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  OPACITY_BLACK_1: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_12: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_16: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_20: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_24: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_28: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_32: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_36: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_4: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_40: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_44: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_48: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_52: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_56: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_60: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_64: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_68: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_72: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_76: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_8: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_80: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_84: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_88: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_92: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLACK_96: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  OPACITY_BLUE_1: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_12: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_16: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_20: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_24: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_28: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_32: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_36: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_4: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_40: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_44: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_48: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_52: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_56: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_60: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_64: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_68: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_72: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_76: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_8: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_80: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_84: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_88: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_92: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLUE_96: 'hsl(209, calc(var(--saturation-factor, 1) * 100.0%), 44.5%)',
  OPACITY_BLURPLE_1: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_12: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_16: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_20: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_24: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_28: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_32: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_36: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_4: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_40: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_44: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_48: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_52: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_56: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_60: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_64: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_68: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_72: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_76: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_8: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_80: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_84: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_88: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_92: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_BLURPLE_96: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  OPACITY_GREEN_1: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_12: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_16: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_20: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_24: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_28: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_32: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_36: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_4: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_40: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_44: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_48: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_52: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_56: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_60: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_64: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_68: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_72: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_76: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_8: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_80: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_84: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_88: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_92: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_GREEN_96: 'hsl(146, calc(var(--saturation-factor, 1) * 100.0%), 26.3%)',
  OPACITY_ORANGE_1: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_12: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_16: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_20: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_24: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_28: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_32: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_36: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_4: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_40: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_44: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_48: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_52: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_56: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_60: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_64: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_68: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_72: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_76: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_8: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_80: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_84: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_88: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_92: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_ORANGE_96: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  OPACITY_PINK_1: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_12: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_16: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_20: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_24: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_28: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_32: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_36: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_4: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_40: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_44: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_48: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_52: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_56: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_60: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_64: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_68: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_72: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_76: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_8: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_80: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_84: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_88: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_92: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_PINK_96: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  OPACITY_RED_1: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_12: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_16: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_20: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_24: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_28: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_32: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_36: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_4: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_40: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_44: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_48: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_52: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_56: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_60: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_64: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_68: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_72: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_76: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_8: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_80: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_84: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_88: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_92: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_RED_96: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  OPACITY_TEAL_1: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_12: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_16: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_20: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_24: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_28: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_32: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_36: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_4: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_40: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_44: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_48: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_52: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_56: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_60: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_64: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_68: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_72: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_76: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_8: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_80: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_84: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_88: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_92: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_TEAL_96: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  OPACITY_WHITE_1: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_12: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_16: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_20: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_24: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_28: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_32: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_36: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_4: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_40: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_44: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_48: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_52: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_56: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_60: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_64: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_68: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_72: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_76: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_8: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_80: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_84: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_88: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_92: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_WHITE_96: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  OPACITY_YELLOW_1: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_12: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_16: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_20: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_24: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_28: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_32: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_36: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_4: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_40: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_44: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_48: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_52: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_56: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_60: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_64: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_68: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_72: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_76: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_8: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_80: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_84: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_88: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_92: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  OPACITY_YELLOW_96: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  ORANGE_100: 'hsl(18, calc(var(--saturation-factor, 1) * 100.0%), 98.0%)',
  ORANGE_130: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 96.5%)',
  ORANGE_160: 'hsl(21, calc(var(--saturation-factor, 1) * 93.9%), 93.5%)',
  ORANGE_200: 'hsl(21, calc(var(--saturation-factor, 1) * 92.3%), 89.8%)',
  ORANGE_230: 'hsl(24, calc(var(--saturation-factor, 1) * 92.5%), 84.3%)',
  ORANGE_260: 'hsl(23, calc(var(--saturation-factor, 1) * 94.5%), 78.6%)',
  ORANGE_300: 'hsl(25, calc(var(--saturation-factor, 1) * 94.6%), 71.2%)',
  ORANGE_330: 'hsl(27, calc(var(--saturation-factor, 1) * 94.7%), 62.7%)',
  ORANGE_345: 'hsl(28, calc(var(--saturation-factor, 1) * 87.7%), 55.5%)',
  ORANGE_360: 'hsl(26, calc(var(--saturation-factor, 1) * 71.3%), 50.8%)',
  ORANGE_400: 'hsl(25, calc(var(--saturation-factor, 1) * 67.5%), 45.9%)',
  ORANGE_430: 'hsl(25, calc(var(--saturation-factor, 1) * 69.5%), 39.8%)',
  ORANGE_460: 'hsl(24, calc(var(--saturation-factor, 1) * 72.2%), 35.3%)',
  ORANGE_500: 'hsl(22, calc(var(--saturation-factor, 1) * 76.1%), 31.2%)',
  ORANGE: 'hsl(22, calc(var(--saturation-factor, 1) * 76.1%), 31.2%)',
  ORANGE_530: 'hsl(22, calc(var(--saturation-factor, 1) * 77.0%), 27.3%)',
  ORANGE_560: 'hsl(21, calc(var(--saturation-factor, 1) * 77.2%), 24.1%)',
  ORANGE_600: 'hsl(23, calc(var(--saturation-factor, 1) * 79.2%), 20.8%)',
  ORANGE_630: 'hsl(22, calc(var(--saturation-factor, 1) * 79.2%), 18.8%)',
  ORANGE_660: 'hsl(22, calc(var(--saturation-factor, 1) * 78.8%), 16.7%)',
  ORANGE_700: 'hsl(22, calc(var(--saturation-factor, 1) * 76.3%), 14.9%)',
  ORANGE_730: 'hsl(22, calc(var(--saturation-factor, 1) * 78.8%), 12.9%)',
  ORANGE_760: 'hsl(21, calc(var(--saturation-factor, 1) * 78.9%), 11.2%)',
  ORANGE_800: 'hsl(21, calc(var(--saturation-factor, 1) * 80.0%), 9.8%)',
  ORANGE_830: 'hsl(20, calc(var(--saturation-factor, 1) * 76.7%), 8.4%)',
  ORANGE_860: 'hsl(20, calc(var(--saturation-factor, 1) * 73.0%), 7.3%)',
  ORANGE_900: 'hsl(26, calc(var(--saturation-factor, 1) * 72.4%), 5.7%)',
  ORANGE_NEW_1: 'hsl(19, calc(var(--saturation-factor, 1) * 100.0%), 91.4%)',
  ORANGE_NEW_10: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 81.2%)',
  ORANGE_NEW_100: 'hsl(353, calc(var(--saturation-factor, 1) * 100.0%), 1.8%)',
  ORANGE_NEW_11: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 80.2%)',
  ORANGE_NEW_12: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 79.2%)',
  ORANGE_NEW_13: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 78.2%)',
  ORANGE_NEW_14: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 77.3%)',
  ORANGE_NEW_15: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 76.5%)',
  ORANGE_NEW_16: 'hsl(23, calc(var(--saturation-factor, 1) * 98.4%), 75.3%)',
  ORANGE_NEW_17: 'hsl(22, calc(var(--saturation-factor, 1) * 95.5%), 74.1%)',
  ORANGE_NEW_18: 'hsl(22, calc(var(--saturation-factor, 1) * 94.2%), 73.1%)',
  ORANGE_NEW_19: 'hsl(23, calc(var(--saturation-factor, 1) * 91.7%), 71.8%)',
  ORANGE_NEW_2: 'hsl(19, calc(var(--saturation-factor, 1) * 100.0%), 90.2%)',
  ORANGE_NEW_20: 'hsl(23, calc(var(--saturation-factor, 1) * 89.3%), 70.6%)',
  ORANGE_NEW_21: 'hsl(23, calc(var(--saturation-factor, 1) * 88.4%), 69.6%)',
  ORANGE_NEW_22: 'hsl(23, calc(var(--saturation-factor, 1) * 86.3%), 68.6%)',
  ORANGE_NEW_23: 'hsl(23, calc(var(--saturation-factor, 1) * 84.3%), 67.5%)',
  ORANGE_NEW_24: 'hsl(23, calc(var(--saturation-factor, 1) * 82.6%), 66.3%)',
  ORANGE_NEW_25: 'hsl(23, calc(var(--saturation-factor, 1) * 80.9%), 65.1%)',
  ORANGE_NEW_26: 'hsl(23, calc(var(--saturation-factor, 1) * 79.2%), 64.1%)',
  ORANGE_NEW_27: 'hsl(23, calc(var(--saturation-factor, 1) * 77.8%), 62.9%)',
  ORANGE_NEW_28: 'hsl(23, calc(var(--saturation-factor, 1) * 76.3%), 62.0%)',
  ORANGE_NEW_29: 'hsl(23, calc(var(--saturation-factor, 1) * 75.0%), 60.8%)',
  ORANGE_NEW_3: 'hsl(21, calc(var(--saturation-factor, 1) * 100.0%), 88.8%)',
  ORANGE_NEW_30: 'hsl(23, calc(var(--saturation-factor, 1) * 73.7%), 59.8%)',
  ORANGE_NEW_31: 'hsl(23, calc(var(--saturation-factor, 1) * 72.5%), 58.6%)',
  ORANGE_NEW_32: 'hsl(23, calc(var(--saturation-factor, 1) * 71.3%), 57.6%)',
  ORANGE_NEW_33: 'hsl(23, calc(var(--saturation-factor, 1) * 70.1%), 56.7%)',
  ORANGE_NEW_34: 'hsl(23, calc(var(--saturation-factor, 1) * 69.2%), 55.5%)',
  ORANGE_NEW_35: 'hsl(23, calc(var(--saturation-factor, 1) * 68.1%), 54.5%)',
  ORANGE_NEW_36: 'hsl(23, calc(var(--saturation-factor, 1) * 67.1%), 53.5%)',
  ORANGE_NEW_37: 'hsl(23, calc(var(--saturation-factor, 1) * 66.1%), 52.5%)',
  ORANGE_NEW_38: 'hsl(23, calc(var(--saturation-factor, 1) * 65.3%), 51.4%)',
  ORANGE_NEW_39: 'hsl(23, calc(var(--saturation-factor, 1) * 64.4%), 50.4%)',
  ORANGE_NEW_4: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 87.6%)',
  ORANGE_NEW_40: 'hsl(23, calc(var(--saturation-factor, 1) * 65.7%), 49.2%)',
  ORANGE_NEW_41: 'hsl(23, calc(var(--saturation-factor, 1) * 67.5%), 48.2%)',
  ORANGE_NEW_42: 'hsl(23, calc(var(--saturation-factor, 1) * 70.0%), 47.1%)',
  ORANGE_NEW_43: 'hsl(23, calc(var(--saturation-factor, 1) * 72.6%), 45.9%)',
  ORANGE_NEW_44: 'hsl(23, calc(var(--saturation-factor, 1) * 75.3%), 44.5%)',
  ORANGE_NEW_45: 'hsl(23, calc(var(--saturation-factor, 1) * 78.3%), 43.3%)',
  ORANGE_NEW_46: 'hsl(24, calc(var(--saturation-factor, 1) * 82.2%), 42.0%)',
  ORANGE_NEW_47: 'hsl(24, calc(var(--saturation-factor, 1) * 86.5%), 40.6%)',
  ORANGE_NEW_48: 'hsl(24, calc(var(--saturation-factor, 1) * 92.9%), 38.8%)',
  ORANGE_NEW_49: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  ORANGE_NEW_5: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 86.5%)',
  ORANGE_NEW_50: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 37.1%)',
  ORANGE_NEW_51: 'hsl(25, calc(var(--saturation-factor, 1) * 98.9%), 36.5%)',
  ORANGE_NEW_52: 'hsl(25, calc(var(--saturation-factor, 1) * 97.8%), 35.9%)',
  ORANGE_NEW_53: 'hsl(24, calc(var(--saturation-factor, 1) * 96.7%), 35.3%)',
  ORANGE_NEW_54: 'hsl(24, calc(var(--saturation-factor, 1) * 96.6%), 34.7%)',
  ORANGE_NEW_55: 'hsl(24, calc(var(--saturation-factor, 1) * 96.5%), 33.9%)',
  ORANGE_NEW_56: 'hsl(24, calc(var(--saturation-factor, 1) * 96.4%), 33.1%)',
  ORANGE_NEW_57: 'hsl(24, calc(var(--saturation-factor, 1) * 96.4%), 32.5%)',
  ORANGE_NEW_58: 'hsl(24, calc(var(--saturation-factor, 1) * 96.3%), 31.8%)',
  ORANGE_NEW_59: 'hsl(24, calc(var(--saturation-factor, 1) * 97.5%), 30.8%)',
  ORANGE_NEW_6: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 85.3%)',
  ORANGE_NEW_60: 'hsl(24, calc(var(--saturation-factor, 1) * 97.4%), 30.2%)',
  ORANGE_NEW_61: 'hsl(24, calc(var(--saturation-factor, 1) * 97.3%), 29.4%)',
  ORANGE_NEW_62: 'hsl(24, calc(var(--saturation-factor, 1) * 98.6%), 28.6%)',
  ORANGE_NEW_63: 'hsl(24, calc(var(--saturation-factor, 1) * 98.6%), 27.8%)',
  ORANGE_NEW_64: 'hsl(24, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  ORANGE_NEW_65: 'hsl(24, calc(var(--saturation-factor, 1) * 100.0%), 26.5%)',
  ORANGE_NEW_66: 'hsl(24, calc(var(--saturation-factor, 1) * 100.0%), 25.7%)',
  ORANGE_NEW_67: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 25.1%)',
  ORANGE_NEW_68: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 24.5%)',
  ORANGE_NEW_69: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 23.7%)',
  ORANGE_NEW_7: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 84.3%)',
  ORANGE_NEW_70: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 23.1%)',
  ORANGE_NEW_71: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 22.5%)',
  ORANGE_NEW_72: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 22.0%)',
  ORANGE_NEW_73: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 21.2%)',
  ORANGE_NEW_74: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 20.6%)',
  ORANGE_NEW_75: 'hsl(21, calc(var(--saturation-factor, 1) * 100.0%), 20.0%)',
  ORANGE_NEW_76: 'hsl(21, calc(var(--saturation-factor, 1) * 100.0%), 19.4%)',
  ORANGE_NEW_77: 'hsl(20, calc(var(--saturation-factor, 1) * 100.0%), 18.8%)',
  ORANGE_NEW_78: 'hsl(20, calc(var(--saturation-factor, 1) * 100.0%), 18.2%)',
  ORANGE_NEW_79: 'hsl(19, calc(var(--saturation-factor, 1) * 100.0%), 17.6%)',
  ORANGE_NEW_8: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 83.1%)',
  ORANGE_NEW_80: 'hsl(19, calc(var(--saturation-factor, 1) * 100.0%), 17.1%)',
  ORANGE_NEW_81: 'hsl(18, calc(var(--saturation-factor, 1) * 100.0%), 16.3%)',
  ORANGE_NEW_82: 'hsl(18, calc(var(--saturation-factor, 1) * 100.0%), 15.7%)',
  ORANGE_NEW_83: 'hsl(17, calc(var(--saturation-factor, 1) * 100.0%), 15.1%)',
  ORANGE_NEW_84: 'hsl(16, calc(var(--saturation-factor, 1) * 100.0%), 14.5%)',
  ORANGE_NEW_85: 'hsl(16, calc(var(--saturation-factor, 1) * 100.0%), 13.9%)',
  ORANGE_NEW_86: 'hsl(15, calc(var(--saturation-factor, 1) * 100.0%), 13.5%)',
  ORANGE_NEW_87: 'hsl(14, calc(var(--saturation-factor, 1) * 100.0%), 12.9%)',
  ORANGE_NEW_88: 'hsl(13, calc(var(--saturation-factor, 1) * 100.0%), 12.4%)',
  ORANGE_NEW_89: 'hsl(12, calc(var(--saturation-factor, 1) * 100.0%), 11.8%)',
  ORANGE_NEW_9: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 82.2%)',
  ORANGE_NEW_90: 'hsl(11, calc(var(--saturation-factor, 1) * 100.0%), 11.2%)',
  ORANGE_NEW_91: 'hsl(10, calc(var(--saturation-factor, 1) * 100.0%), 10.6%)',
  ORANGE_NEW_92: 'hsl(8, calc(var(--saturation-factor, 1) * 100.0%), 10.0%)',
  ORANGE_NEW_93: 'hsl(8, calc(var(--saturation-factor, 1) * 100.0%), 9.4%)',
  ORANGE_NEW_94: 'hsl(7, calc(var(--saturation-factor, 1) * 100.0%), 8.8%)',
  ORANGE_NEW_95: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 8.2%)',
  ORANGE_NEW_96: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 7.5%)',
  ORANGE_NEW_97: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 6.5%)',
  ORANGE_NEW_98: 'hsl(0, calc(var(--saturation-factor, 1) * 100.0%), 5.3%)',
  ORANGE_NEW_99: 'hsl(357, calc(var(--saturation-factor, 1) * 100.0%), 3.9%)',
  PARTNER: 'hsl(215, calc(var(--saturation-factor, 1) * 82.8%), 59.0%)',
  PAYPAL: 'hsl(230, calc(var(--saturation-factor, 1) * 69.8%), 24.7%)',
  PINK_1: 'hsl(310, calc(var(--saturation-factor, 1) * 100.0%), 91.4%)',
  PINK_10: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 87.3%)',
  PINK_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.0%)',
  PINK_11: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 86.9%)',
  PINK_12: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 86.5%)',
  PINK_13: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 85.9%)',
  PINK_14: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 85.3%)',
  PINK_15: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 84.9%)',
  PINK_16: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 84.3%)',
  PINK_17: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 83.9%)',
  PINK_18: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 83.3%)',
  PINK_19: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 82.7%)',
  PINK_2: 'hsl(310, calc(var(--saturation-factor, 1) * 100.0%), 91.0%)',
  PINK_20: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 82.4%)',
  PINK_21: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 81.8%)',
  PINK_22: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 81.2%)',
  PINK_23: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 80.6%)',
  PINK_24: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 80.0%)',
  PINK_25: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 79.4%)',
  PINK_26: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 78.8%)',
  PINK_27: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 78.2%)',
  PINK_28: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 77.6%)',
  PINK_29: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 77.1%)',
  PINK_3: 'hsl(310, calc(var(--saturation-factor, 1) * 100.0%), 90.6%)',
  PINK_30: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 76.5%)',
  PINK_31: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 75.9%)',
  PINK_32: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 75.1%)',
  PINK_33: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 74.5%)',
  PINK_34: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 73.9%)',
  PINK_35: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 73.1%)',
  PINK_36: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 72.7%)',
  PINK_37: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 72.2%)',
  PINK_38: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 71.6%)',
  PINK_39: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 71.2%)',
  PINK_4: 'hsl(311, calc(var(--saturation-factor, 1) * 100.0%), 90.0%)',
  PINK_40: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 70.6%)',
  PINK_41: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 70.0%)',
  PINK_42: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 69.4%)',
  PINK_43: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 68.8%)',
  PINK_44: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 68.2%)',
  PINK_45: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 67.6%)',
  PINK_46: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 67.1%)',
  PINK_47: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 66.3%)',
  PINK_48: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 65.7%)',
  PINK_49: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  PINK_5: 'hsl(311, calc(var(--saturation-factor, 1) * 100.0%), 89.6%)',
  PINK_50: 'hsl(315, calc(var(--saturation-factor, 1) * 100.0%), 64.9%)',
  PINK_51: 'hsl(315, calc(var(--saturation-factor, 1) * 93.5%), 63.5%)',
  PINK_52: 'hsl(315, calc(var(--saturation-factor, 1) * 87.6%), 62.2%)',
  PINK_53: 'hsl(315, calc(var(--saturation-factor, 1) * 82.9%), 61.0%)',
  PINK_54: 'hsl(315, calc(var(--saturation-factor, 1) * 77.7%), 59.6%)',
  PINK_55: 'hsl(316, calc(var(--saturation-factor, 1) * 73.7%), 58.2%)',
  PINK_56: 'hsl(315, calc(var(--saturation-factor, 1) * 69.1%), 56.9%)',
  PINK_57: 'hsl(316, calc(var(--saturation-factor, 1) * 65.6%), 55.5%)',
  PINK_58: 'hsl(315, calc(var(--saturation-factor, 1) * 61.5%), 54.1%)',
  PINK_59: 'hsl(316, calc(var(--saturation-factor, 1) * 58.5%), 52.7%)',
  PINK_6: 'hsl(312, calc(var(--saturation-factor, 1) * 100.0%), 89.2%)',
  PINK_60: 'hsl(316, calc(var(--saturation-factor, 1) * 55.5%), 51.6%)',
  PINK_61: 'hsl(316, calc(var(--saturation-factor, 1) * 52.8%), 50.2%)',
  PINK_62: 'hsl(316, calc(var(--saturation-factor, 1) * 51.8%), 48.8%)',
  PINK_63: 'hsl(316, calc(var(--saturation-factor, 1) * 52.1%), 47.5%)',
  PINK_64: 'hsl(316, calc(var(--saturation-factor, 1) * 52.3%), 46.1%)',
  PINK_65: 'hsl(316, calc(var(--saturation-factor, 1) * 52.0%), 44.9%)',
  PINK_66: 'hsl(316, calc(var(--saturation-factor, 1) * 52.3%), 43.5%)',
  PINK_67: 'hsl(316, calc(var(--saturation-factor, 1) * 52.8%), 42.4%)',
  PINK_68: 'hsl(316, calc(var(--saturation-factor, 1) * 53.1%), 41.0%)',
  PINK_69: 'hsl(316, calc(var(--saturation-factor, 1) * 52.7%), 39.8%)',
  PINK_7: 'hsl(313, calc(var(--saturation-factor, 1) * 100.0%), 88.8%)',
  PINK_70: 'hsl(316, calc(var(--saturation-factor, 1) * 53.1%), 38.4%)',
  PINK_71: 'hsl(316, calc(var(--saturation-factor, 1) * 53.4%), 37.1%)',
  PINK_72: 'hsl(316, calc(var(--saturation-factor, 1) * 54.1%), 35.9%)',
  PINK_73: 'hsl(316, calc(var(--saturation-factor, 1) * 54.5%), 34.5%)',
  PINK_74: 'hsl(316, calc(var(--saturation-factor, 1) * 54.1%), 33.3%)',
  PINK_75: 'hsl(317, calc(var(--saturation-factor, 1) * 54.9%), 32.2%)',
  PINK_76: 'hsl(316, calc(var(--saturation-factor, 1) * 55.4%), 30.8%)',
  PINK_77: 'hsl(316, calc(var(--saturation-factor, 1) * 56.3%), 29.6%)',
  PINK_78: 'hsl(316, calc(var(--saturation-factor, 1) * 55.9%), 28.4%)',
  PINK_79: 'hsl(317, calc(var(--saturation-factor, 1) * 56.8%), 27.3%)',
  PINK_8: 'hsl(313, calc(var(--saturation-factor, 1) * 100.0%), 88.2%)',
  PINK_80: 'hsl(317, calc(var(--saturation-factor, 1) * 57.6%), 25.9%)',
  PINK_81: 'hsl(316, calc(var(--saturation-factor, 1) * 57.5%), 24.9%)',
  PINK_82: 'hsl(316, calc(var(--saturation-factor, 1) * 58.3%), 23.5%)',
  PINK_83: 'hsl(317, calc(var(--saturation-factor, 1) * 59.6%), 22.4%)',
  PINK_84: 'hsl(317, calc(var(--saturation-factor, 1) * 59.6%), 21.4%)',
  PINK_85: 'hsl(316, calc(var(--saturation-factor, 1) * 60.8%), 20.0%)',
  PINK_86: 'hsl(316, calc(var(--saturation-factor, 1) * 60.8%), 19.0%)',
  PINK_87: 'hsl(317, calc(var(--saturation-factor, 1) * 62.6%), 17.8%)',
  PINK_88: 'hsl(316, calc(var(--saturation-factor, 1) * 64.3%), 16.5%)',
  PINK_89: 'hsl(316, calc(var(--saturation-factor, 1) * 64.6%), 15.5%)',
  PINK_9: 'hsl(314, calc(var(--saturation-factor, 1) * 100.0%), 87.8%)',
  PINK_90: 'hsl(316, calc(var(--saturation-factor, 1) * 64.9%), 14.5%)',
  PINK_91: 'hsl(317, calc(var(--saturation-factor, 1) * 67.6%), 13.3%)',
  PINK_92: 'hsl(317, calc(var(--saturation-factor, 1) * 68.3%), 12.4%)',
  PINK_93: 'hsl(316, calc(var(--saturation-factor, 1) * 71.9%), 11.2%)',
  PINK_94: 'hsl(317, calc(var(--saturation-factor, 1) * 73.1%), 10.2%)',
  PINK_95: 'hsl(316, calc(var(--saturation-factor, 1) * 73.9%), 9.0%)',
  PINK_96: 'hsl(317, calc(var(--saturation-factor, 1) * 75.6%), 8.0%)',
  PINK_97: 'hsl(318, calc(var(--saturation-factor, 1) * 76.5%), 6.7%)',
  PINK_98: 'hsl(321, calc(var(--saturation-factor, 1) * 76.9%), 5.1%)',
  PINK_99: 'hsl(327, calc(var(--saturation-factor, 1) * 73.3%), 2.9%)',
  PLAYSTATION: 'hsl(220, calc(var(--saturation-factor, 1) * 95.7%), 27.1%)',
  PLUM_23_ALPHA: 'hsl(240, calc(var(--saturation-factor, 1) * 63.4%), 83.9%)',
  PLUM_0: 'hsl(240, calc(var(--saturation-factor, 1) * 9.1%), 97.8%)',
  PLUM_1: 'hsl(240, calc(var(--saturation-factor, 1) * 4.3%), 95.5%)',
  PLUM_10: 'hsl(229, calc(var(--saturation-factor, 1) * 6.8%), 53.7%)',
  PLUM_11: 'hsl(229, calc(var(--saturation-factor, 1) * 6.9%), 45.5%)',
  PLUM_12: 'hsl(228, calc(var(--saturation-factor, 1) * 7.6%), 38.6%)',
  PLUM_13: 'hsl(227, calc(var(--saturation-factor, 1) * 8.3%), 32.9%)',
  PLUM_14: 'hsl(230, calc(var(--saturation-factor, 1) * 8.5%), 27.8%)',
  PLUM_15: 'hsl(229, calc(var(--saturation-factor, 1) * 8.9%), 24.1%)',
  PLUM_16: 'hsl(234, calc(var(--saturation-factor, 1) * 9.3%), 21.2%)',
  PLUM_17: 'hsl(233, calc(var(--saturation-factor, 1) * 9.3%), 19.0%)',
  PLUM_18: 'hsl(233, calc(var(--saturation-factor, 1) * 10.6%), 16.7%)',
  PLUM_19: 'hsl(233, calc(var(--saturation-factor, 1) * 10.8%), 14.5%)',
  PLUM_2: 'hsl(220, calc(var(--saturation-factor, 1) * 8.6%), 93.1%)',
  PLUM_20: 'hsl(231, calc(var(--saturation-factor, 1) * 11.1%), 12.4%)',
  PLUM_21: 'hsl(231, calc(var(--saturation-factor, 1) * 12.7%), 10.8%)',
  PLUM_22: 'hsl(240, calc(var(--saturation-factor, 1) * 12.0%), 9.8%)',
  PLUM_23: 'hsl(240, calc(var(--saturation-factor, 1) * 11.6%), 8.4%)',
  PLUM_24: 'hsl(228, calc(var(--saturation-factor, 1) * 14.3%), 6.9%)',
  PLUM_25: 'hsl(240, calc(var(--saturation-factor, 1) * 14.3%), 5.5%)',
  PLUM_26: 'hsl(240, calc(var(--saturation-factor, 1) * 15.8%), 3.7%)',
  PLUM_3: 'hsl(225, calc(var(--saturation-factor, 1) * 8.0%), 90.2%)',
  PLUM_4: 'hsl(225, calc(var(--saturation-factor, 1) * 6.2%), 87.5%)',
  PLUM_5: 'hsl(220, calc(var(--saturation-factor, 1) * 7.3%), 83.9%)',
  PLUM_6: 'hsl(231, calc(var(--saturation-factor, 1) * 6.7%), 79.4%)',
  PLUM_7: 'hsl(227, calc(var(--saturation-factor, 1) * 6.8%), 73.9%)',
  PLUM_8: 'hsl(230, calc(var(--saturation-factor, 1) * 7.4%), 68.2%)',
  PLUM_9: 'hsl(231, calc(var(--saturation-factor, 1) * 7.1%), 61.2%)',
  PREMIUM_NITRO_PINK_DARK: 'hsl(299, calc(var(--saturation-factor, 1) * 43.1%), 50.4%)',
  PREMIUM_NITRO_PINK_LIGHT: 'hsl(299, calc(var(--saturation-factor, 1) * 42.9%), 58.8%)',
  PREMIUM_PERK_BLUE: 'hsl(222, calc(var(--saturation-factor, 1) * 100.0%), 75.1%)',
  PREMIUM_PERK_BLUE_ALT: 'hsl(223, calc(var(--saturation-factor, 1) * 100.0%), 80.6%)',
  PREMIUM_PERK_DARK_BLUE: 'hsl(220, calc(var(--saturation-factor, 1) * 67.4%), 55.5%)',
  PREMIUM_PERK_GOLD: 'hsl(38, calc(var(--saturation-factor, 1) * 95.7%), 54.1%)',
  PREMIUM_PERK_GREEN: 'hsl(164, calc(var(--saturation-factor, 1) * 55.1%), 69.4%)',
  PREMIUM_PERK_LIGHT_BLUE: 'hsl(221, calc(var(--saturation-factor, 1) * 100.0%), 84.1%)',
  PREMIUM_PERK_ORANGE: 'hsl(25, calc(var(--saturation-factor, 1) * 96.7%), 64.1%)',
  PREMIUM_PERK_PINK: 'hsl(305, calc(var(--saturation-factor, 1) * 100.0%), 75.1%)',
  PREMIUM_PERK_PURPLE: 'hsl(272, calc(var(--saturation-factor, 1) * 100.0%), 80.2%)',
  PREMIUM_PERK_YELLOW: 'hsl(47, calc(var(--saturation-factor, 1) * 98.9%), 63.9%)',
  PREMIUM_TIER_0_BLUE: 'hsl(202, calc(var(--saturation-factor, 1) * 100.0%), 38.0%)',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS: 'hsl(202, calc(var(--saturation-factor, 1) * 100.0%), 38.0%)',
  PREMIUM_TIER_0_BLUE_FOR_GRADIENTS_2: 'hsl(209, calc(var(--saturation-factor, 1) * 80.0%), 45.1%)',
  PREMIUM_TIER_0_HEADER_GRADIENT_1: 'hsl(240, calc(var(--saturation-factor, 1) * 55.2%), 47.3%)',
  PREMIUM_TIER_0_HEADER_GRADIENT_2: 'hsl(224, calc(var(--saturation-factor, 1) * 77.9%), 59.2%)',
  PREMIUM_TIER_0_HEADER_GRADIENT_3: 'hsl(246, calc(var(--saturation-factor, 1) * 74.4%), 69.4%)',
  PREMIUM_TIER_0_HEADER_GRADIENT_4: 'hsl(295, calc(var(--saturation-factor, 1) * 79.9%), 72.7%)',
  PREMIUM_TIER_0_HEADER_GRADIENT_5: 'hsl(336, calc(var(--saturation-factor, 1) * 55.2%), 72.0%)',
  PREMIUM_TIER_0_PURPLE: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  PREMIUM_TIER_0_PURPLE_FOR_GRADIENTS: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  PREMIUM_TIER_1_BLUE: 'hsl(228, calc(var(--saturation-factor, 1) * 86.7%), 70.6%)',
  PREMIUM_TIER_1_BLUE_FOR_GRADIENTS: 'hsl(235, calc(var(--saturation-factor, 1) * 85.6%), 64.7%)',
  PREMIUM_TIER_1_DARK_BLUE_FOR_GRADIENTS: 'hsl(235, calc(var(--saturation-factor, 1) * 68.5%), 52.7%)',
  PREMIUM_TIER_1_PURPLE: 'hsl(244, calc(var(--saturation-factor, 1) * 100.0%), 84.1%)',
  PREMIUM_TIER_2_PINK: 'hsl(342, calc(var(--saturation-factor, 1) * 58.0%), 72.9%)',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS: 'hsl(325, calc(var(--saturation-factor, 1) * 31.7%), 51.8%)',
  PREMIUM_TIER_2_PINK_FOR_GRADIENTS_2: 'hsl(295, calc(var(--saturation-factor, 1) * 51.4%), 50.0%)',
  PREMIUM_TIER_2_PURPLE: 'hsl(270, calc(var(--saturation-factor, 1) * 86.7%), 70.6%)',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS: 'hsl(269, calc(var(--saturation-factor, 1) * 52.7%), 52.7%)',
  PREMIUM_TIER_2_PURPLE_FOR_GRADIENTS_2: 'hsl(296, calc(var(--saturation-factor, 1) * 50.0%), 51.4%)',
  PRIMARY_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 97.6%)',
  PRIMARY_130: 'hsl(220, calc(var(--saturation-factor, 1) * 13.0%), 95.5%)',
  PRIMARY_160: 'hsl(210, calc(var(--saturation-factor, 1) * 11.1%), 92.9%)',
  PRIMARY_200: 'hsl(216, calc(var(--saturation-factor, 1) * 9.8%), 90.0%)',
  PRIMARY_230: 'hsl(210, calc(var(--saturation-factor, 1) * 9.1%), 87.1%)',
  PRIMARY_260: 'hsl(214, calc(var(--saturation-factor, 1) * 8.4%), 83.7%)',
  PRIMARY_300: 'hsl(210, calc(var(--saturation-factor, 1) * 9.3%), 78.8%)',
  PRIMARY_330: 'hsl(215, calc(var(--saturation-factor, 1) * 8.8%), 73.3%)',
  PRIMARY_345: 'hsl(214, calc(var(--saturation-factor, 1) * 8.4%), 67.5%)',
  PRIMARY_360: 'hsl(214, calc(var(--saturation-factor, 1) * 8.1%), 61.2%)',
  PRIMARY_400: 'hsl(223, calc(var(--saturation-factor, 1) * 5.8%), 52.9%)',
  PRIMARY_430: 'hsl(229, calc(var(--saturation-factor, 1) * 4.8%), 44.9%)',
  PRIMARY_460: 'hsl(228, calc(var(--saturation-factor, 1) * 5.2%), 38.0%)',
  PRIMARY_500: 'hsl(228, calc(var(--saturation-factor, 1) * 6.0%), 32.5%)',
  PRIMARY: 'hsl(228, calc(var(--saturation-factor, 1) * 6.0%), 32.5%)',
  PRIMARY_530: 'hsl(227, calc(var(--saturation-factor, 1) * 6.5%), 27.3%)',
  PRIMARY_560: 'hsl(225, calc(var(--saturation-factor, 1) * 6.7%), 23.5%)',
  PRIMARY_600: 'hsl(223, calc(var(--saturation-factor, 1) * 6.7%), 20.6%)',
  PRIMARY_630: 'hsl(220, calc(var(--saturation-factor, 1) * 6.5%), 18.0%)',
  PRIMARY_645: 'hsl(220, calc(var(--saturation-factor, 1) * 7.0%), 16.9%)',
  PRIMARY_660: 'hsl(228, calc(var(--saturation-factor, 1) * 6.7%), 14.7%)',
  PRIMARY_700: 'hsl(225, calc(var(--saturation-factor, 1) * 6.3%), 12.5%)',
  PRIMARY_730: 'hsl(225, calc(var(--saturation-factor, 1) * 7.1%), 11.0%)',
  PRIMARY_760: 'hsl(220, calc(var(--saturation-factor, 1) * 6.4%), 9.2%)',
  PRIMARY_800: 'hsl(220, calc(var(--saturation-factor, 1) * 8.1%), 7.3%)',
  PRIMARY_830: 'hsl(240, calc(var(--saturation-factor, 1) * 4.0%), 4.9%)',
  PRIMARY_860: 'hsl(240, calc(var(--saturation-factor, 1) * 7.7%), 2.5%)',
  PRIMARY_900: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 0.8%)',
  RED_100: 'hsl(350, calc(var(--saturation-factor, 1) * 75.0%), 98.4%)',
  RED_130: 'hsl(0, calc(var(--saturation-factor, 1) * 83.3%), 97.6%)',
  RED_160: 'hsl(0, calc(var(--saturation-factor, 1) * 90.9%), 95.7%)',
  RED_200: 'hsl(358, calc(var(--saturation-factor, 1) * 88.9%), 92.9%)',
  RED_230: 'hsl(359, calc(var(--saturation-factor, 1) * 85.2%), 89.4%)',
  RED_260: 'hsl(359, calc(var(--saturation-factor, 1) * 89.0%), 85.7%)',
  RED_300: 'hsl(359, calc(var(--saturation-factor, 1) * 91.4%), 81.8%)',
  RED_330: 'hsl(359, calc(var(--saturation-factor, 1) * 91.3%), 77.5%)',
  RED_345: 'hsl(358, calc(var(--saturation-factor, 1) * 92.9%), 72.4%)',
  RED_360: 'hsl(358, calc(var(--saturation-factor, 1) * 91.8%), 66.5%)',
  RED_400: 'hsl(359, calc(var(--saturation-factor, 1) * 87.3%), 59.8%)',
  RED_430: 'hsl(358, calc(var(--saturation-factor, 1) * 68.8%), 53.5%)',
  RED_460: 'hsl(359, calc(var(--saturation-factor, 1) * 59.1%), 46.1%)',
  RED_500: 'hsl(360, calc(var(--saturation-factor, 1) * 60.2%), 39.4%)',
  RED: 'hsl(360, calc(var(--saturation-factor, 1) * 60.2%), 39.4%)',
  RED_530: 'hsl(359, calc(var(--saturation-factor, 1) * 63.4%), 34.3%)',
  RED_560: 'hsl(359, calc(var(--saturation-factor, 1) * 63.9%), 30.4%)',
  RED_600: 'hsl(359, calc(var(--saturation-factor, 1) * 64.7%), 26.7%)',
  RED_630: 'hsl(359, calc(var(--saturation-factor, 1) * 65.6%), 23.9%)',
  RED_660: 'hsl(359, calc(var(--saturation-factor, 1) * 65.1%), 21.4%)',
  RED_700: 'hsl(358, calc(var(--saturation-factor, 1) * 66.7%), 18.8%)',
  RED_730: 'hsl(359, calc(var(--saturation-factor, 1) * 66.7%), 16.5%)',
  RED_760: 'hsl(359, calc(var(--saturation-factor, 1) * 70.3%), 14.5%)',
  RED_800: 'hsl(359, calc(var(--saturation-factor, 1) * 68.8%), 12.5%)',
  RED_830: 'hsl(358, calc(var(--saturation-factor, 1) * 67.3%), 10.8%)',
  RED_860: 'hsl(0, calc(var(--saturation-factor, 1) * 66.7%), 9.4%)',
  RED_900: 'hsl(0, calc(var(--saturation-factor, 1) * 70.0%), 7.8%)',
  RED_NEW_1: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 92.7%)',
  RED_NEW_10: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 85.7%)',
  RED_NEW_100: 'hsl(345, calc(var(--saturation-factor, 1) * 100.0%), 0.8%)',
  RED_NEW_11: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 84.9%)',
  RED_NEW_12: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 84.1%)',
  RED_NEW_13: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 83.3%)',
  RED_NEW_14: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 82.5%)',
  RED_NEW_15: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 81.8%)',
  RED_NEW_16: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 80.8%)',
  RED_NEW_17: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 80.0%)',
  RED_NEW_18: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 79.2%)',
  RED_NEW_19: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 78.4%)',
  RED_NEW_2: 'hsl(1, calc(var(--saturation-factor, 1) * 100.0%), 92.0%)',
  RED_NEW_20: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 77.8%)',
  RED_NEW_21: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 77.3%)',
  RED_NEW_22: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 76.5%)',
  RED_NEW_23: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 75.9%)',
  RED_NEW_24: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 75.3%)',
  RED_NEW_25: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 74.7%)',
  RED_NEW_26: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 74.1%)',
  RED_NEW_27: 'hsl(2, calc(var(--saturation-factor, 1) * 98.5%), 73.3%)',
  RED_NEW_28: 'hsl(2, calc(var(--saturation-factor, 1) * 95.7%), 72.4%)',
  RED_NEW_29: 'hsl(2, calc(var(--saturation-factor, 1) * 93.2%), 71.4%)',
  RED_NEW_3: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 91.2%)',
  RED_NEW_30: 'hsl(2, calc(var(--saturation-factor, 1) * 90.7%), 70.4%)',
  RED_NEW_31: 'hsl(1, calc(var(--saturation-factor, 1) * 89.7%), 69.6%)',
  RED_NEW_32: 'hsl(1, calc(var(--saturation-factor, 1) * 87.5%), 68.6%)',
  RED_NEW_33: 'hsl(1, calc(var(--saturation-factor, 1) * 85.5%), 67.6%)',
  RED_NEW_34: 'hsl(1, calc(var(--saturation-factor, 1) * 83.5%), 66.7%)',
  RED_NEW_35: 'hsl(1, calc(var(--saturation-factor, 1) * 81.7%), 65.7%)',
  RED_NEW_36: 'hsl(1, calc(var(--saturation-factor, 1) * 80.0%), 64.7%)',
  RED_NEW_37: 'hsl(0, calc(var(--saturation-factor, 1) * 78.3%), 63.9%)',
  RED_NEW_38: 'hsl(0, calc(var(--saturation-factor, 1) * 76.7%), 62.9%)',
  RED_NEW_39: 'hsl(360, calc(var(--saturation-factor, 1) * 75.4%), 61.8%)',
  RED_NEW_4: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 90.4%)',
  RED_NEW_40: 'hsl(360, calc(var(--saturation-factor, 1) * 74.0%), 60.8%)',
  RED_NEW_41: 'hsl(359, calc(var(--saturation-factor, 1) * 72.8%), 59.6%)',
  RED_NEW_42: 'hsl(359, calc(var(--saturation-factor, 1) * 71.6%), 58.6%)',
  RED_NEW_43: 'hsl(358, calc(var(--saturation-factor, 1) * 70.5%), 57.5%)',
  RED_NEW_44: 'hsl(358, calc(var(--saturation-factor, 1) * 68.8%), 56.1%)',
  RED_NEW_45: 'hsl(358, calc(var(--saturation-factor, 1) * 67.8%), 54.9%)',
  RED_NEW_46: 'hsl(357, calc(var(--saturation-factor, 1) * 66.9%), 53.7%)',
  RED_NEW_47: 'hsl(357, calc(var(--saturation-factor, 1) * 66.1%), 52.5%)',
  RED_NEW_48: 'hsl(356, calc(var(--saturation-factor, 1) * 65.3%), 51.4%)',
  RED_NEW_49: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  RED_NEW_5: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 89.6%)',
  RED_NEW_50: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 50.0%)',
  RED_NEW_51: 'hsl(356, calc(var(--saturation-factor, 1) * 64.8%), 49.0%)',
  RED_NEW_52: 'hsl(356, calc(var(--saturation-factor, 1) * 64.1%), 48.0%)',
  RED_NEW_53: 'hsl(356, calc(var(--saturation-factor, 1) * 64.2%), 47.1%)',
  RED_NEW_54: 'hsl(356, calc(var(--saturation-factor, 1) * 64.3%), 46.1%)',
  RED_NEW_55: 'hsl(356, calc(var(--saturation-factor, 1) * 64.2%), 44.9%)',
  RED_NEW_56: 'hsl(356, calc(var(--saturation-factor, 1) * 64.3%), 43.9%)',
  RED_NEW_57: 'hsl(356, calc(var(--saturation-factor, 1) * 63.6%), 43.1%)',
  RED_NEW_58: 'hsl(356, calc(var(--saturation-factor, 1) * 63.7%), 42.2%)',
  RED_NEW_59: 'hsl(356, calc(var(--saturation-factor, 1) * 63.8%), 41.2%)',
  RED_NEW_6: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 88.8%)',
  RED_NEW_60: 'hsl(356, calc(var(--saturation-factor, 1) * 64.7%), 40.0%)',
  RED_NEW_61: 'hsl(356, calc(var(--saturation-factor, 1) * 64.8%), 39.0%)',
  RED_NEW_62: 'hsl(356, calc(var(--saturation-factor, 1) * 64.9%), 38.0%)',
  RED_NEW_63: 'hsl(356, calc(var(--saturation-factor, 1) * 65.1%), 37.1%)',
  RED_NEW_64: 'hsl(356, calc(var(--saturation-factor, 1) * 65.2%), 36.1%)',
  RED_NEW_65: 'hsl(356, calc(var(--saturation-factor, 1) * 65.4%), 35.1%)',
  RED_NEW_66: 'hsl(356, calc(var(--saturation-factor, 1) * 65.7%), 34.3%)',
  RED_NEW_67: 'hsl(356, calc(var(--saturation-factor, 1) * 66.9%), 33.1%)',
  RED_NEW_68: 'hsl(356, calc(var(--saturation-factor, 1) * 67.1%), 32.2%)',
  RED_NEW_69: 'hsl(356, calc(var(--saturation-factor, 1) * 67.3%), 31.2%)',
  RED_NEW_7: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 88.0%)',
  RED_NEW_70: 'hsl(356, calc(var(--saturation-factor, 1) * 67.7%), 30.4%)',
  RED_NEW_71: 'hsl(355, calc(var(--saturation-factor, 1) * 69.1%), 29.2%)',
  RED_NEW_72: 'hsl(356, calc(var(--saturation-factor, 1) * 69.4%), 28.2%)',
  RED_NEW_73: 'hsl(356, calc(var(--saturation-factor, 1) * 70.0%), 27.5%)',
  RED_NEW_74: 'hsl(355, calc(var(--saturation-factor, 1) * 71.6%), 26.3%)',
  RED_NEW_75: 'hsl(356, calc(var(--saturation-factor, 1) * 72.3%), 25.5%)',
  RED_NEW_76: 'hsl(355, calc(var(--saturation-factor, 1) * 72.8%), 24.5%)',
  RED_NEW_77: 'hsl(355, calc(var(--saturation-factor, 1) * 75.0%), 23.5%)',
  RED_NEW_78: 'hsl(354, calc(var(--saturation-factor, 1) * 75.7%), 22.5%)',
  RED_NEW_79: 'hsl(355, calc(var(--saturation-factor, 1) * 76.6%), 21.8%)',
  RED_NEW_8: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 87.3%)',
  RED_NEW_80: 'hsl(354, calc(var(--saturation-factor, 1) * 79.0%), 20.6%)',
  RED_NEW_81: 'hsl(354, calc(var(--saturation-factor, 1) * 80.2%), 19.8%)',
  RED_NEW_82: 'hsl(354, calc(var(--saturation-factor, 1) * 81.4%), 19.0%)',
  RED_NEW_83: 'hsl(354, calc(var(--saturation-factor, 1) * 82.6%), 18.0%)',
  RED_NEW_84: 'hsl(354, calc(var(--saturation-factor, 1) * 86.2%), 17.1%)',
  RED_NEW_85: 'hsl(353, calc(var(--saturation-factor, 1) * 87.8%), 16.1%)',
  RED_NEW_86: 'hsl(354, calc(var(--saturation-factor, 1) * 87.3%), 15.5%)',
  RED_NEW_87: 'hsl(354, calc(var(--saturation-factor, 1) * 89.3%), 14.7%)',
  RED_NEW_88: 'hsl(354, calc(var(--saturation-factor, 1) * 91.5%), 13.9%)',
  RED_NEW_89: 'hsl(353, calc(var(--saturation-factor, 1) * 93.9%), 12.9%)',
  RED_NEW_9: 'hsl(3, calc(var(--saturation-factor, 1) * 100.0%), 86.5%)',
  RED_NEW_90: 'hsl(354, calc(var(--saturation-factor, 1) * 93.7%), 12.4%)',
  RED_NEW_91: 'hsl(354, calc(var(--saturation-factor, 1) * 96.6%), 11.6%)',
  RED_NEW_92: 'hsl(353, calc(var(--saturation-factor, 1) * 96.4%), 11.0%)',
  RED_NEW_93: 'hsl(353, calc(var(--saturation-factor, 1) * 100.0%), 10.0%)',
  RED_NEW_94: 'hsl(354, calc(var(--saturation-factor, 1) * 100.0%), 9.4%)',
  RED_NEW_95: 'hsl(353, calc(var(--saturation-factor, 1) * 100.0%), 8.6%)',
  RED_NEW_96: 'hsl(354, calc(var(--saturation-factor, 1) * 100.0%), 7.6%)',
  RED_NEW_97: 'hsl(355, calc(var(--saturation-factor, 1) * 100.0%), 6.7%)',
  RED_NEW_98: 'hsl(353, calc(var(--saturation-factor, 1) * 100.0%), 5.3%)',
  RED_NEW_99: 'hsl(353, calc(var(--saturation-factor, 1) * 100.0%), 3.5%)',
  REDDIT: 'hsl(16, calc(var(--saturation-factor, 1) * 100.0%), 50.0%)',
  RIOT_GAMES: 'hsl(349, calc(var(--saturation-factor, 1) * 100.0%), 45.9%)',
  ROLE_BLUE: 'hsl(204, calc(var(--saturation-factor, 1) * 64.4%), 35.3%)',
  ROLE_BROWN: 'hsl(24, calc(var(--saturation-factor, 1) * 100.0%), 32.9%)',
  ROLE_BURGUNDY: 'hsl(334, calc(var(--saturation-factor, 1) * 79.3%), 37.8%)',
  ROLE_DARK_BLUE: 'hsl(199, calc(var(--saturation-factor, 1) * 18.4%), 40.4%)',
  ROLE_DARK_GREY: 'hsl(200, calc(var(--saturation-factor, 1) * 18.3%), 46.1%)',
  ROLE_DARK_PURPLE: 'hsl(282, calc(var(--saturation-factor, 1) * 43.7%), 37.6%)',
  ROLE_DARK_TEAL: 'hsl(168, calc(var(--saturation-factor, 1) * 76.6%), 28.4%)',
  ROLE_DEFAULT: 'hsl(204, calc(var(--saturation-factor, 1) * 15.9%), 65.5%)',
  ROLE_GREEN: 'hsl(145, calc(var(--saturation-factor, 1) * 63.5%), 33.3%)',
  ROLE_GREY: 'hsl(202, calc(var(--saturation-factor, 1) * 4.0%), 60.8%)',
  ROLE_LIGHT_BLUE: 'hsl(204, calc(var(--saturation-factor, 1) * 15.9%), 65.5%)',
  ROLE_LIGHT_GREEN: 'hsl(145, calc(var(--saturation-factor, 1) * 63.2%), 49.0%)',
  ROLE_LIGHT_GREY: 'hsl(184, calc(var(--saturation-factor, 1) * 8.7%), 61.8%)',
  ROLE_MAGENTA: 'hsl(340, calc(var(--saturation-factor, 1) * 82.2%), 51.6%)',
  ROLE_ORANGE: 'hsl(28, calc(var(--saturation-factor, 1) * 79.7%), 51.8%)',
  ROLE_PURPLE: 'hsl(283, calc(var(--saturation-factor, 1) * 38.9%), 53.1%)',
  ROLE_SALMON: 'hsl(6, calc(var(--saturation-factor, 1) * 78.1%), 57.1%)',
  ROLE_SKY_BLUE: 'hsl(204, calc(var(--saturation-factor, 1) * 69.9%), 53.1%)',
  ROLE_TAN: 'hsl(37, calc(var(--saturation-factor, 1) * 86.5%), 40.8%)',
  ROLE_TEAL: 'hsl(168, calc(var(--saturation-factor, 1) * 75.7%), 42.0%)',
  ROLE_TERRACOTTA: 'hsl(6, calc(var(--saturation-factor, 1) * 63.6%), 36.7%)',
  ROLE_YELLOW: 'hsl(48, calc(var(--saturation-factor, 1) * 89.0%), 50.2%)',
  SAMSUNG: 'hsl(231, calc(var(--saturation-factor, 1) * 77.8%), 35.3%)',
  SKYPE: 'hsl(196, calc(var(--saturation-factor, 1) * 100.0%), 42.2%)',
  SPOTIFY: 'hsl(141, calc(var(--saturation-factor, 1) * 72.9%), 42.0%)',
  STEAM: 'hsl(215, calc(var(--saturation-factor, 1) * 35.1%), 14.5%)',
  TEAL_100: 'hsl(193, calc(var(--saturation-factor, 1) * 69.2%), 97.5%)',
  TEAL_130: 'hsl(192, calc(var(--saturation-factor, 1) * 83.3%), 95.3%)',
  TEAL_160: 'hsl(190, calc(var(--saturation-factor, 1) * 83.3%), 90.6%)',
  TEAL_200: 'hsl(188, calc(var(--saturation-factor, 1) * 85.7%), 83.5%)',
  TEAL_230: 'hsl(188, calc(var(--saturation-factor, 1) * 88.3%), 73.1%)',
  TEAL_260: 'hsl(188, calc(var(--saturation-factor, 1) * 81.9%), 65.3%)',
  TEAL_300: 'hsl(189, calc(var(--saturation-factor, 1) * 72.8%), 58.2%)',
  TEAL_330: 'hsl(189, calc(var(--saturation-factor, 1) * 65.6%), 52.2%)',
  TEAL_345: 'hsl(190, calc(var(--saturation-factor, 1) * 62.8%), 48.4%)',
  TEAL_360: 'hsl(190, calc(var(--saturation-factor, 1) * 64.0%), 43.5%)',
  TEAL_400: 'hsl(190, calc(var(--saturation-factor, 1) * 63.5%), 38.6%)',
  TEAL_430: 'hsl(190, calc(var(--saturation-factor, 1) * 63.0%), 33.9%)',
  TEAL_460: 'hsl(191, calc(var(--saturation-factor, 1) * 64.2%), 29.6%)',
  TEAL_500: 'hsl(190, calc(var(--saturation-factor, 1) * 65.2%), 25.9%)',
  TEAL: 'hsl(190, calc(var(--saturation-factor, 1) * 65.2%), 25.9%)',
  TEAL_530: 'hsl(190, calc(var(--saturation-factor, 1) * 66.7%), 22.4%)',
  TEAL_560: 'hsl(190, calc(var(--saturation-factor, 1) * 69.7%), 19.4%)',
  TEAL_600: 'hsl(189, calc(var(--saturation-factor, 1) * 71.8%), 16.7%)',
  TEAL_630: 'hsl(190, calc(var(--saturation-factor, 1) * 73.7%), 14.9%)',
  TEAL_660: 'hsl(188, calc(var(--saturation-factor, 1) * 75.8%), 12.9%)',
  TEAL_700: 'hsl(189, calc(var(--saturation-factor, 1) * 79.3%), 11.4%)',
  TEAL_730: 'hsl(189, calc(var(--saturation-factor, 1) * 80.0%), 9.8%)',
  TEAL_760: 'hsl(189, calc(var(--saturation-factor, 1) * 81.4%), 8.4%)',
  TEAL_800: 'hsl(188, calc(var(--saturation-factor, 1) * 83.3%), 7.1%)',
  TEAL_830: 'hsl(189, calc(var(--saturation-factor, 1) * 87.1%), 6.1%)',
  TEAL_860: 'hsl(188, calc(var(--saturation-factor, 1) * 85.2%), 5.3%)',
  TEAL_900: 'hsl(189, calc(var(--saturation-factor, 1) * 90.9%), 4.3%)',
  TEAL_NEW_1: 'hsl(180, calc(var(--saturation-factor, 1) * 100.0%), 84.7%)',
  TEAL_NEW_10: 'hsl(185, calc(var(--saturation-factor, 1) * 74.2%), 75.7%)',
  TEAL_NEW_100: 'hsl(207, calc(var(--saturation-factor, 1) * 100.0%), 2.2%)',
  TEAL_NEW_11: 'hsl(185, calc(var(--saturation-factor, 1) * 70.8%), 74.5%)',
  TEAL_NEW_12: 'hsl(185, calc(var(--saturation-factor, 1) * 67.6%), 73.3%)',
  TEAL_NEW_13: 'hsl(186, calc(var(--saturation-factor, 1) * 66.0%), 72.4%)',
  TEAL_NEW_14: 'hsl(185, calc(var(--saturation-factor, 1) * 63.3%), 71.2%)',
  TEAL_NEW_15: 'hsl(185, calc(var(--saturation-factor, 1) * 60.8%), 70.0%)',
  TEAL_NEW_16: 'hsl(185, calc(var(--saturation-factor, 1) * 58.5%), 68.8%)',
  TEAL_NEW_17: 'hsl(185, calc(var(--saturation-factor, 1) * 57.3%), 67.8%)',
  TEAL_NEW_18: 'hsl(185, calc(var(--saturation-factor, 1) * 55.0%), 66.9%)',
  TEAL_NEW_19: 'hsl(185, calc(var(--saturation-factor, 1) * 53.1%), 65.7%)',
  TEAL_NEW_2: 'hsl(182, calc(var(--saturation-factor, 1) * 100.0%), 83.9%)',
  TEAL_NEW_20: 'hsl(185, calc(var(--saturation-factor, 1) * 52.2%), 64.7%)',
  TEAL_NEW_21: 'hsl(185, calc(var(--saturation-factor, 1) * 50.5%), 63.5%)',
  TEAL_NEW_22: 'hsl(185, calc(var(--saturation-factor, 1) * 49.0%), 62.4%)',
  TEAL_NEW_23: 'hsl(185, calc(var(--saturation-factor, 1) * 48.2%), 61.4%)',
  TEAL_NEW_24: 'hsl(185, calc(var(--saturation-factor, 1) * 46.8%), 60.2%)',
  TEAL_NEW_25: 'hsl(185, calc(var(--saturation-factor, 1) * 45.5%), 59.0%)',
  TEAL_NEW_26: 'hsl(185, calc(var(--saturation-factor, 1) * 44.9%), 58.0%)',
  TEAL_NEW_27: 'hsl(185, calc(var(--saturation-factor, 1) * 43.6%), 56.9%)',
  TEAL_NEW_28: 'hsl(186, calc(var(--saturation-factor, 1) * 42.9%), 56.1%)',
  TEAL_NEW_29: 'hsl(185, calc(var(--saturation-factor, 1) * 41.7%), 54.9%)',
  TEAL_NEW_3: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 83.3%)',
  TEAL_NEW_30: 'hsl(185, calc(var(--saturation-factor, 1) * 40.7%), 53.7%)',
  TEAL_NEW_31: 'hsl(186, calc(var(--saturation-factor, 1) * 40.2%), 52.7%)',
  TEAL_NEW_32: 'hsl(185, calc(var(--saturation-factor, 1) * 39.3%), 51.6%)',
  TEAL_NEW_33: 'hsl(185, calc(var(--saturation-factor, 1) * 39.1%), 50.4%)',
  TEAL_NEW_34: 'hsl(185, calc(var(--saturation-factor, 1) * 39.4%), 49.2%)',
  TEAL_NEW_35: 'hsl(185, calc(var(--saturation-factor, 1) * 40.4%), 48.0%)',
  TEAL_NEW_36: 'hsl(185, calc(var(--saturation-factor, 1) * 41.7%), 47.1%)',
  TEAL_NEW_37: 'hsl(185, calc(var(--saturation-factor, 1) * 43.3%), 45.7%)',
  TEAL_NEW_38: 'hsl(185, calc(var(--saturation-factor, 1) * 44.7%), 44.7%)',
  TEAL_NEW_39: 'hsl(185, calc(var(--saturation-factor, 1) * 46.6%), 43.3%)',
  TEAL_NEW_4: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 82.7%)',
  TEAL_NEW_40: 'hsl(185, calc(var(--saturation-factor, 1) * 48.1%), 42.4%)',
  TEAL_NEW_41: 'hsl(185, calc(var(--saturation-factor, 1) * 50.2%), 41.0%)',
  TEAL_NEW_42: 'hsl(185, calc(var(--saturation-factor, 1) * 52.7%), 39.8%)',
  TEAL_NEW_43: 'hsl(184, calc(var(--saturation-factor, 1) * 55.1%), 38.4%)',
  TEAL_NEW_44: 'hsl(185, calc(var(--saturation-factor, 1) * 58.7%), 37.1%)',
  TEAL_NEW_45: 'hsl(185, calc(var(--saturation-factor, 1) * 62.6%), 35.7%)',
  TEAL_NEW_46: 'hsl(185, calc(var(--saturation-factor, 1) * 67.6%), 33.9%)',
  TEAL_NEW_47: 'hsl(184, calc(var(--saturation-factor, 1) * 74.4%), 32.2%)',
  TEAL_NEW_48: 'hsl(184, calc(var(--saturation-factor, 1) * 84.2%), 29.8%)',
  TEAL_NEW_49: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  TEAL_NEW_5: 'hsl(185, calc(var(--saturation-factor, 1) * 93.7%), 81.4%)',
  TEAL_NEW_50: 'hsl(184, calc(var(--saturation-factor, 1) * 100.0%), 27.1%)',
  TEAL_NEW_51: 'hsl(184, calc(var(--saturation-factor, 1) * 97.1%), 26.9%)',
  TEAL_NEW_52: 'hsl(184, calc(var(--saturation-factor, 1) * 95.6%), 26.7%)',
  TEAL_NEW_53: 'hsl(184, calc(var(--saturation-factor, 1) * 94.0%), 26.3%)',
  TEAL_NEW_54: 'hsl(184, calc(var(--saturation-factor, 1) * 93.9%), 25.7%)',
  TEAL_NEW_55: 'hsl(184, calc(var(--saturation-factor, 1) * 92.2%), 25.3%)',
  TEAL_NEW_56: 'hsl(185, calc(var(--saturation-factor, 1) * 92.1%), 24.9%)',
  TEAL_NEW_57: 'hsl(184, calc(var(--saturation-factor, 1) * 91.9%), 24.3%)',
  TEAL_NEW_58: 'hsl(185, calc(var(--saturation-factor, 1) * 93.4%), 23.7%)',
  TEAL_NEW_59: 'hsl(184, calc(var(--saturation-factor, 1) * 93.2%), 23.1%)',
  TEAL_NEW_6: 'hsl(185, calc(var(--saturation-factor, 1) * 88.1%), 80.2%)',
  TEAL_NEW_60: 'hsl(184, calc(var(--saturation-factor, 1) * 94.7%), 22.4%)',
  TEAL_NEW_61: 'hsl(184, calc(var(--saturation-factor, 1) * 96.4%), 21.8%)',
  TEAL_NEW_62: 'hsl(185, calc(var(--saturation-factor, 1) * 98.1%), 21.0%)',
  TEAL_NEW_63: 'hsl(185, calc(var(--saturation-factor, 1) * 98.1%), 20.6%)',
  TEAL_NEW_64: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 19.8%)',
  TEAL_NEW_65: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 19.4%)',
  TEAL_NEW_66: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 18.8%)',
  TEAL_NEW_67: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 18.4%)',
  TEAL_NEW_68: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 17.8%)',
  TEAL_NEW_69: 'hsl(185, calc(var(--saturation-factor, 1) * 100.0%), 17.5%)',
  TEAL_NEW_7: 'hsl(185, calc(var(--saturation-factor, 1) * 84.9%), 79.2%)',
  TEAL_NEW_70: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 17.1%)',
  TEAL_NEW_71: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 16.5%)',
  TEAL_NEW_72: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 16.1%)',
  TEAL_NEW_73: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 15.5%)',
  TEAL_NEW_74: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 15.1%)',
  TEAL_NEW_75: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 14.7%)',
  TEAL_NEW_76: 'hsl(186, calc(var(--saturation-factor, 1) * 100.0%), 14.1%)',
  TEAL_NEW_77: 'hsl(187, calc(var(--saturation-factor, 1) * 100.0%), 13.7%)',
  TEAL_NEW_78: 'hsl(187, calc(var(--saturation-factor, 1) * 100.0%), 13.3%)',
  TEAL_NEW_79: 'hsl(187, calc(var(--saturation-factor, 1) * 100.0%), 12.9%)',
  TEAL_NEW_8: 'hsl(185, calc(var(--saturation-factor, 1) * 80.4%), 78.0%)',
  TEAL_NEW_80: 'hsl(188, calc(var(--saturation-factor, 1) * 100.0%), 12.4%)',
  TEAL_NEW_81: 'hsl(188, calc(var(--saturation-factor, 1) * 100.0%), 12.0%)',
  TEAL_NEW_82: 'hsl(188, calc(var(--saturation-factor, 1) * 100.0%), 11.6%)',
  TEAL_NEW_83: 'hsl(188, calc(var(--saturation-factor, 1) * 100.0%), 11.2%)',
  TEAL_NEW_84: 'hsl(188, calc(var(--saturation-factor, 1) * 100.0%), 10.6%)',
  TEAL_NEW_85: 'hsl(189, calc(var(--saturation-factor, 1) * 100.0%), 10.2%)',
  TEAL_NEW_86: 'hsl(190, calc(var(--saturation-factor, 1) * 100.0%), 9.8%)',
  TEAL_NEW_87: 'hsl(190, calc(var(--saturation-factor, 1) * 100.0%), 9.4%)',
  TEAL_NEW_88: 'hsl(190, calc(var(--saturation-factor, 1) * 100.0%), 9.0%)',
  TEAL_NEW_89: 'hsl(191, calc(var(--saturation-factor, 1) * 100.0%), 8.6%)',
  TEAL_NEW_9: 'hsl(185, calc(var(--saturation-factor, 1) * 76.5%), 76.7%)',
  TEAL_NEW_90: 'hsl(190, calc(var(--saturation-factor, 1) * 100.0%), 8.0%)',
  TEAL_NEW_91: 'hsl(191, calc(var(--saturation-factor, 1) * 100.0%), 7.6%)',
  TEAL_NEW_92: 'hsl(191, calc(var(--saturation-factor, 1) * 100.0%), 7.3%)',
  TEAL_NEW_93: 'hsl(192, calc(var(--saturation-factor, 1) * 100.0%), 6.9%)',
  TEAL_NEW_94: 'hsl(195, calc(var(--saturation-factor, 1) * 100.0%), 6.5%)',
  TEAL_NEW_95: 'hsl(195, calc(var(--saturation-factor, 1) * 100.0%), 6.1%)',
  TEAL_NEW_96: 'hsl(195, calc(var(--saturation-factor, 1) * 100.0%), 5.5%)',
  TEAL_NEW_97: 'hsl(197, calc(var(--saturation-factor, 1) * 100.0%), 4.9%)',
  TEAL_NEW_98: 'hsl(200, calc(var(--saturation-factor, 1) * 100.0%), 4.1%)',
  TEAL_NEW_99: 'hsl(205, calc(var(--saturation-factor, 1) * 100.0%), 3.3%)',
  TRANSPARENT: 'transparent',
  TWITCH: 'hsl(264, calc(var(--saturation-factor, 1) * 100.0%), 63.9%)',
  TWITCH_SECONDARY: 'hsl(264, calc(var(--saturation-factor, 1) * 80.3%), 54.1%)',
  TWITTER: 'hsl(203, calc(var(--saturation-factor, 1) * 89.1%), 53.1%)',
  WHITE: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_100: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_130: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_160: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_200: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_230: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_260: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_300: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_330: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_345: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_360: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_400: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_430: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_460: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_500: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 100.0%)',
  WHITE_530: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 91.0%)',
  WHITE_560: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 81.2%)',
  WHITE_600: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 67.8%)',
  WHITE_630: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 58.8%)',
  WHITE_660: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 51.4%)',
  WHITE_700: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 40.0%)',
  WHITE_730: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 37.3%)',
  WHITE_760: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 34.5%)',
  WHITE_800: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 30.2%)',
  WHITE_830: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 23.1%)',
  WHITE_860: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 14.9%)',
  WHITE_900: 'hsl(0, calc(var(--saturation-factor, 1) * 0.0%), 5.1%)',
  XBOX: 'hsl(120, calc(var(--saturation-factor, 1) * 77.1%), 27.5%)',
  YELLOW_100: 'hsl(34, calc(var(--saturation-factor, 1) * 100.0%), 96.9%)',
  YELLOW_130: 'hsl(31, calc(var(--saturation-factor, 1) * 100.0%), 95.5%)',
  YELLOW_160: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 91.4%)',
  YELLOW_200: 'hsl(35, calc(var(--saturation-factor, 1) * 97.3%), 85.5%)',
  YELLOW_230: 'hsl(37, calc(var(--saturation-factor, 1) * 96.6%), 77.1%)',
  YELLOW_260: 'hsl(41, calc(var(--saturation-factor, 1) * 96.8%), 62.9%)',
  YELLOW_300: 'hsl(40, calc(var(--saturation-factor, 1) * 86.4%), 56.9%)',
  YELLOW_330: 'hsl(40, calc(var(--saturation-factor, 1) * 75.3%), 52.4%)',
  YELLOW_345: 'hsl(40, calc(var(--saturation-factor, 1) * 71.0%), 48.6%)',
  YELLOW_360: 'hsl(39, calc(var(--saturation-factor, 1) * 74.4%), 42.9%)',
  YELLOW_400: 'hsl(38, calc(var(--saturation-factor, 1) * 78.6%), 38.4%)',
  YELLOW_430: 'hsl(37, calc(var(--saturation-factor, 1) * 84.4%), 32.7%)',
  YELLOW_460: 'hsl(36, calc(var(--saturation-factor, 1) * 87.8%), 28.8%)',
  YELLOW_500: 'hsl(36, calc(var(--saturation-factor, 1) * 93.8%), 25.1%)',
  YELLOW: 'hsl(36, calc(var(--saturation-factor, 1) * 93.8%), 25.1%)',
  YELLOW_530: 'hsl(35, calc(var(--saturation-factor, 1) * 92.9%), 22.2%)',
  YELLOW_560: 'hsl(34, calc(var(--saturation-factor, 1) * 94.0%), 19.6%)',
  YELLOW_600: 'hsl(35, calc(var(--saturation-factor, 1) * 93.1%), 17.1%)',
  YELLOW_630: 'hsl(35, calc(var(--saturation-factor, 1) * 92.4%), 15.5%)',
  YELLOW_660: 'hsl(35, calc(var(--saturation-factor, 1) * 91.4%), 13.7%)',
  YELLOW_700: 'hsl(34, calc(var(--saturation-factor, 1) * 90.3%), 12.2%)',
  YELLOW_730: 'hsl(33, calc(var(--saturation-factor, 1) * 92.7%), 10.8%)',
  YELLOW_760: 'hsl(33, calc(var(--saturation-factor, 1) * 91.7%), 9.4%)',
  YELLOW_800: 'hsl(32, calc(var(--saturation-factor, 1) * 90.2%), 8.0%)',
  YELLOW_830: 'hsl(32, calc(var(--saturation-factor, 1) * 88.9%), 7.1%)',
  YELLOW_860: 'hsl(32, calc(var(--saturation-factor, 1) * 86.7%), 5.9%)',
  YELLOW_900: 'hsl(36, calc(var(--saturation-factor, 1) * 83.3%), 4.7%)',
  YELLOW_NEW_1: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 89.4%)',
  YELLOW_NEW_10: 'hsl(33, calc(var(--saturation-factor, 1) * 87.3%), 78.4%)',
  YELLOW_NEW_100: 'hsl(0, calc(var(--saturation-factor, 1) * 100.0%), 2.7%)',
  YELLOW_NEW_11: 'hsl(33, calc(var(--saturation-factor, 1) * 84.5%), 77.3%)',
  YELLOW_NEW_12: 'hsl(33, calc(var(--saturation-factor, 1) * 82.1%), 75.9%)',
  YELLOW_NEW_13: 'hsl(33, calc(var(--saturation-factor, 1) * 79.8%), 74.7%)',
  YELLOW_NEW_14: 'hsl(33, calc(var(--saturation-factor, 1) * 77.9%), 73.3%)',
  YELLOW_NEW_15: 'hsl(33, calc(var(--saturation-factor, 1) * 76.1%), 72.2%)',
  YELLOW_NEW_16: 'hsl(34, calc(var(--saturation-factor, 1) * 74.3%), 71.0%)',
  YELLOW_NEW_17: 'hsl(34, calc(var(--saturation-factor, 1) * 72.7%), 69.8%)',
  YELLOW_NEW_18: 'hsl(34, calc(var(--saturation-factor, 1) * 70.2%), 68.4%)',
  YELLOW_NEW_19: 'hsl(34, calc(var(--saturation-factor, 1) * 68.9%), 67.3%)',
  YELLOW_NEW_2: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 88.2%)',
  YELLOW_NEW_20: 'hsl(34, calc(var(--saturation-factor, 1) * 67.6%), 66.1%)',
  YELLOW_NEW_21: 'hsl(34, calc(var(--saturation-factor, 1) * 66.3%), 65.1%)',
  YELLOW_NEW_22: 'hsl(34, calc(var(--saturation-factor, 1) * 64.3%), 63.7%)',
  YELLOW_NEW_23: 'hsl(34, calc(var(--saturation-factor, 1) * 63.4%), 62.5%)',
  YELLOW_NEW_24: 'hsl(34, calc(var(--saturation-factor, 1) * 62.2%), 61.6%)',
  YELLOW_NEW_25: 'hsl(34, calc(var(--saturation-factor, 1) * 61.4%), 60.4%)',
  YELLOW_NEW_26: 'hsl(34, calc(var(--saturation-factor, 1) * 59.6%), 59.2%)',
  YELLOW_NEW_27: 'hsl(34, calc(var(--saturation-factor, 1) * 58.7%), 58.2%)',
  YELLOW_NEW_28: 'hsl(34, calc(var(--saturation-factor, 1) * 58.0%), 57.1%)',
  YELLOW_NEW_29: 'hsl(34, calc(var(--saturation-factor, 1) * 56.4%), 55.9%)',
  YELLOW_NEW_3: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 87.1%)',
  YELLOW_NEW_30: 'hsl(34, calc(var(--saturation-factor, 1) * 55.7%), 54.9%)',
  YELLOW_NEW_31: 'hsl(35, calc(var(--saturation-factor, 1) * 55.1%), 53.7%)',
  YELLOW_NEW_32: 'hsl(35, calc(var(--saturation-factor, 1) * 53.7%), 52.5%)',
  YELLOW_NEW_33: 'hsl(34, calc(var(--saturation-factor, 1) * 53.0%), 51.6%)',
  YELLOW_NEW_34: 'hsl(35, calc(var(--saturation-factor, 1) * 52.4%), 50.6%)',
  YELLOW_NEW_35: 'hsl(34, calc(var(--saturation-factor, 1) * 52.6%), 49.6%)',
  YELLOW_NEW_36: 'hsl(34, calc(var(--saturation-factor, 1) * 54.5%), 48.2%)',
  YELLOW_NEW_37: 'hsl(35, calc(var(--saturation-factor, 1) * 56.0%), 47.3%)',
  YELLOW_NEW_38: 'hsl(34, calc(var(--saturation-factor, 1) * 57.6%), 46.3%)',
  YELLOW_NEW_39: 'hsl(34, calc(var(--saturation-factor, 1) * 59.1%), 45.1%)',
  YELLOW_NEW_4: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 85.9%)',
  YELLOW_NEW_40: 'hsl(35, calc(var(--saturation-factor, 1) * 61.6%), 43.9%)',
  YELLOW_NEW_41: 'hsl(35, calc(var(--saturation-factor, 1) * 63.5%), 42.9%)',
  YELLOW_NEW_42: 'hsl(34, calc(var(--saturation-factor, 1) * 66.2%), 41.8%)',
  YELLOW_NEW_43: 'hsl(35, calc(var(--saturation-factor, 1) * 68.9%), 40.4%)',
  YELLOW_NEW_44: 'hsl(35, calc(var(--saturation-factor, 1) * 72.0%), 39.2%)',
  YELLOW_NEW_45: 'hsl(35, calc(var(--saturation-factor, 1) * 75.3%), 38.0%)',
  YELLOW_NEW_46: 'hsl(35, calc(var(--saturation-factor, 1) * 79.7%), 36.7%)',
  YELLOW_NEW_47: 'hsl(36, calc(var(--saturation-factor, 1) * 84.4%), 35.1%)',
  YELLOW_NEW_48: 'hsl(37, calc(var(--saturation-factor, 1) * 91.8%), 33.3%)',
  YELLOW_NEW_49: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  YELLOW_NEW_5: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 84.9%)',
  YELLOW_NEW_50: 'hsl(37, calc(var(--saturation-factor, 1) * 100.0%), 31.6%)',
  YELLOW_NEW_51: 'hsl(37, calc(var(--saturation-factor, 1) * 98.7%), 31.2%)',
  YELLOW_NEW_52: 'hsl(36, calc(var(--saturation-factor, 1) * 97.5%), 30.8%)',
  YELLOW_NEW_53: 'hsl(36, calc(var(--saturation-factor, 1) * 97.4%), 30.2%)',
  YELLOW_NEW_54: 'hsl(36, calc(var(--saturation-factor, 1) * 96.1%), 29.8%)',
  YELLOW_NEW_55: 'hsl(36, calc(var(--saturation-factor, 1) * 96.0%), 29.2%)',
  YELLOW_NEW_56: 'hsl(36, calc(var(--saturation-factor, 1) * 95.9%), 28.6%)',
  YELLOW_NEW_57: 'hsl(35, calc(var(--saturation-factor, 1) * 95.8%), 28.0%)',
  YELLOW_NEW_58: 'hsl(35, calc(var(--saturation-factor, 1) * 95.7%), 27.5%)',
  YELLOW_NEW_59: 'hsl(35, calc(var(--saturation-factor, 1) * 97.1%), 26.7%)',
  YELLOW_NEW_6: 'hsl(31, calc(var(--saturation-factor, 1) * 100.0%), 83.9%)',
  YELLOW_NEW_60: 'hsl(35, calc(var(--saturation-factor, 1) * 97.0%), 26.1%)',
  YELLOW_NEW_61: 'hsl(35, calc(var(--saturation-factor, 1) * 98.4%), 25.3%)',
  YELLOW_NEW_62: 'hsl(35, calc(var(--saturation-factor, 1) * 98.4%), 24.9%)',
  YELLOW_NEW_63: 'hsl(35, calc(var(--saturation-factor, 1) * 100.0%), 24.1%)',
  YELLOW_NEW_64: 'hsl(35, calc(var(--saturation-factor, 1) * 100.0%), 23.5%)',
  YELLOW_NEW_65: 'hsl(34, calc(var(--saturation-factor, 1) * 100.0%), 22.9%)',
  YELLOW_NEW_66: 'hsl(34, calc(var(--saturation-factor, 1) * 100.0%), 22.4%)',
  YELLOW_NEW_67: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 22.0%)',
  YELLOW_NEW_68: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 21.4%)',
  YELLOW_NEW_69: 'hsl(33, calc(var(--saturation-factor, 1) * 100.0%), 20.8%)',
  YELLOW_NEW_7: 'hsl(32, calc(var(--saturation-factor, 1) * 97.8%), 82.5%)',
  YELLOW_NEW_70: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 20.4%)',
  YELLOW_NEW_71: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 19.8%)',
  YELLOW_NEW_72: 'hsl(32, calc(var(--saturation-factor, 1) * 100.0%), 19.2%)',
  YELLOW_NEW_73: 'hsl(31, calc(var(--saturation-factor, 1) * 100.0%), 18.8%)',
  YELLOW_NEW_74: 'hsl(31, calc(var(--saturation-factor, 1) * 100.0%), 18.2%)',
  YELLOW_NEW_75: 'hsl(30, calc(var(--saturation-factor, 1) * 100.0%), 17.8%)',
  YELLOW_NEW_76: 'hsl(30, calc(var(--saturation-factor, 1) * 100.0%), 17.3%)',
  YELLOW_NEW_77: 'hsl(30, calc(var(--saturation-factor, 1) * 100.0%), 16.7%)',
  YELLOW_NEW_78: 'hsl(28, calc(var(--saturation-factor, 1) * 100.0%), 16.3%)',
  YELLOW_NEW_79: 'hsl(28, calc(var(--saturation-factor, 1) * 100.0%), 15.7%)',
  YELLOW_NEW_8: 'hsl(32, calc(var(--saturation-factor, 1) * 93.8%), 81.2%)',
  YELLOW_NEW_80: 'hsl(27, calc(var(--saturation-factor, 1) * 100.0%), 15.3%)',
  YELLOW_NEW_81: 'hsl(26, calc(var(--saturation-factor, 1) * 100.0%), 14.7%)',
  YELLOW_NEW_82: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 14.3%)',
  YELLOW_NEW_83: 'hsl(25, calc(var(--saturation-factor, 1) * 100.0%), 13.7%)',
  YELLOW_NEW_84: 'hsl(24, calc(var(--saturation-factor, 1) * 100.0%), 13.3%)',
  YELLOW_NEW_85: 'hsl(23, calc(var(--saturation-factor, 1) * 100.0%), 12.7%)',
  YELLOW_NEW_86: 'hsl(22, calc(var(--saturation-factor, 1) * 100.0%), 12.4%)',
  YELLOW_NEW_87: 'hsl(21, calc(var(--saturation-factor, 1) * 100.0%), 11.8%)',
  YELLOW_NEW_88: 'hsl(21, calc(var(--saturation-factor, 1) * 100.0%), 11.4%)',
  YELLOW_NEW_89: 'hsl(19, calc(var(--saturation-factor, 1) * 100.0%), 11.0%)',
  YELLOW_NEW_9: 'hsl(32, calc(var(--saturation-factor, 1) * 90.3%), 79.8%)',
  YELLOW_NEW_90: 'hsl(18, calc(var(--saturation-factor, 1) * 100.0%), 10.4%)',
  YELLOW_NEW_91: 'hsl(16, calc(var(--saturation-factor, 1) * 100.0%), 10.0%)',
  YELLOW_NEW_92: 'hsl(15, calc(var(--saturation-factor, 1) * 100.0%), 9.4%)',
  YELLOW_NEW_93: 'hsl(13, calc(var(--saturation-factor, 1) * 100.0%), 9.0%)',
  YELLOW_NEW_94: 'hsl(11, calc(var(--saturation-factor, 1) * 100.0%), 8.4%)',
  YELLOW_NEW_95: 'hsl(9, calc(var(--saturation-factor, 1) * 100.0%), 7.8%)',
  YELLOW_NEW_96: 'hsl(6, calc(var(--saturation-factor, 1) * 100.0%), 7.3%)',
  YELLOW_NEW_97: 'hsl(4, calc(var(--saturation-factor, 1) * 100.0%), 6.5%)',
  YELLOW_NEW_98: 'hsl(2, calc(var(--saturation-factor, 1) * 100.0%), 5.7%)',
  YELLOW_NEW_99: 'hsl(0, calc(var(--saturation-factor, 1) * 100.0%), 4.5%)',
  YOUTUBE: 'hsl(0, calc(var(--saturation-factor, 1) * 72.8%), 46.1%)',
});

export default Colors as Record<keyof typeof Colors, string>;
